import type { Translations } from '../index';

export const es: Translations = {
  errors: {
    generic: {
      unknownTitle: 'No se pudo completar la acción',
      unknownMessage: 'Tu trabajo está a salvo. Vuelve a intentar la acción en un momento.',
      badRequestTitle: 'No pudimos procesar esa solicitud',
      badRequestMessage: 'Revisa los datos marcados e inténtalo de nuevo.',
      notFoundTitle: 'No encontrado',
      notFoundMessage: 'No encontramos lo que buscabas. Es posible que se haya movido o eliminado.',
      conflictTitle: 'Esto ya existe',
      conflictMessage: 'Este elemento ya existe o cambió en otro lugar. Actualiza e inténtalo de nuevo.',
      unsupportedFileTitle: 'Archivo no admitido',
      unsupportedFileMessage: 'Ese tipo de archivo no es compatible aquí. Prueba con otro archivo.',
      fileTooLargeTitle: 'Archivo demasiado grande',
      fileTooLargeMessage: 'Ese archivo supera el tamaño permitido. Prueba con uno más pequeño.',
      retry: 'Reintentar',
      dismiss: 'Cerrar',
    },
    network: {
      offlineTitle: 'Parece que no tienes conexión',
      offlineMessage: 'Revisa tu conexión a internet e inténtalo de nuevo.',
      timeoutTitle: 'Esto está tardando más de lo esperado',
      timeoutMessage: 'La solicitud expiró. Tu trabajo está guardado: inténtalo de nuevo.',
      serviceUnavailableTitle: 'Servicio no disponible temporalmente',
      serviceUnavailableMessage: 'Estamos brevemente no disponibles. Inténtalo de nuevo en unos segundos.',
      serverErrorTitle: 'Nuestro servicio tiene problemas',
      serverErrorMessage: 'Ya fuimos notificados y estamos trabajando en ello. Inténtalo de nuevo en breve.',
    },
    auth: {
      sessionExpiredTitle: 'Tu sesión expiró',
      sessionExpiredMessage: 'Por tu seguridad, vuelve a iniciar sesión para continuar.',
      signInCta: 'Iniciar sesión',
      invalidCredentialsTitle: 'Correo o contraseña incorrectos',
      invalidCredentialsMessage: 'Verifica tus credenciales e inténtalo de nuevo.',
      accountLockedTitle: 'Cuenta bloqueada temporalmente',
      accountLockedMessage: 'Demasiados intentos. Inténtalo de nuevo en unos minutos.',
      accountDeactivatedTitle: 'Cuenta desactivada',
      accountDeactivatedMessage: 'Esta cuenta está desactivada. Contacta a tu administrador.',
      forbiddenTitle: 'No tienes acceso',
      forbiddenMessage: 'No tienes permiso para esta acción.',
      invalidCodeTitle: 'Ese código no funcionó',
      invalidCodeMessage: 'El código de verificación es inválido o expiró. Solicita uno nuevo.',
      currentPasswordWrongTitle: 'La contraseña actual es incorrecta',
      currentPasswordWrongMessage: 'Vuelve a ingresar tu contraseña actual e inténtalo de nuevo.',
      userExistsTitle: 'La cuenta ya existe',
      userExistsMessage: 'Ya existe una cuenta con este correo. Intenta iniciar sesión.',
    },
    credits: {
      insufficientTitle: 'Créditos insuficientes',
      insufficientMessage: 'No tienes suficientes créditos para completar esto. Agrega créditos o mejora tu plan para continuar.',
      buyCreditsCta: 'Comprar créditos',
      minAmountTitle: 'Cantidad demasiado baja',
      minAmountMessage: 'La compra mínima es de 10 créditos.',
      invalidAmountTitle: 'Ingresa una cantidad válida',
      invalidAmountMessage: 'Ingresa un número de créditos válido.',
      noPaymentMethodTitle: 'Agrega un método de pago',
      noPaymentMethodMessage: 'Agrega un método de pago antes de continuar.',
      checkoutFailedTitle: 'No se pudo iniciar el pago',
      checkoutFailedMessage: 'No pudimos abrir el pago. Inténtalo de nuevo.',
    },
    orders: {
      notFoundTitle: 'Orden no encontrada',
      notFoundMessage: 'Esta orden no existe o no tienes acceso a ella.',
      accessDeniedTitle: 'Acceso denegado',
      accessDeniedMessage: 'No tienes acceso a esta orden.',
      createFailedTitle: 'No pudimos crear tu orden',
      createFailedMessage: 'Algo interrumpió la creación de la orden. Tu archivo sigue aquí: inténtalo de nuevo.',
    },
    corpus: {
      notFoundTitle: 'Corpus no encontrado',
      notFoundMessage: 'Este corpus no existe o fue eliminado.',
      duplicateTermTitle: 'Término duplicado',
      duplicateTermMessage: 'Este término ya está en el glosario.',
    },
    plan: {
      limitTitle: 'Alcanzaste el límite de tu plan',
      limitMessage: 'Alcanzaste lo que permite tu plan actual. Mejora tu plan para continuar.',
      upgradeCta: 'Mejorar plan',
      alreadyFreeTitle: 'Estás en el plan Gratis',
      alreadyFreeMessage: 'Ya estás en el plan Gratis. Elige un plan de pago para desbloquear más.',
    },
    processing: {
      timeoutTitle: 'El procesamiento está tardando demasiado',
      timeoutMessage: 'El servicio de documentos expiró. Tu archivo está a salvo: inténtalo de nuevo.',
      failedTitle: 'No pudimos terminar el procesamiento',
      failedMessage: 'Algo interrumpió el procesamiento. Inténtalo de nuevo.',
    },
  },
  formatTemplates: {
    title: 'Plantillas de formato',
    subtitle: "Define hoja, márgenes, letra, encabezado, numeración, guiones y fórmula de cierre. La plantilla se aplica en la Opción 4 al revisar una orden.",
    adminTitle: 'Plantillas de formato globales',
    adminSubtitle: "Plantillas de EZDocu disponibles para todas las cuentas. Cada cuenta elige cuál activar (o ninguna); no se aplican solas.",
    newTemplate: 'Nueva plantilla',
    newGlobalTemplate: 'Nueva plantilla global',
    duplicateBtn: 'Duplicar',
    duplicateFromGlobalHint: 'Crea una copia propia editable a partir de esta plantilla de EZDocu',
    editBtn: 'Editar',
    deleteBtn: 'Eliminar',
    confirmDeleteBtn: '¿Eliminar?',
    setDefaultBtn: 'Predeterminada',
    defaultBadge: 'Predeterminada',
    globalBadge: 'EZDocu',
    ownBadge: 'Propia',
    myTemplates: 'Mis plantillas',
    globalTemplates: 'Plantillas de EZDocu',
    filterAll: 'Todas',
    filterGlobal: 'Globales',
    filterAccounts: 'De cuentas',
    loading: 'Cargando plantillas…',
    empty: 'Aún no tienes plantillas propias. Duplica una de EZDocu o crea una nueva.',
    emptyAdmin: 'No hay plantillas.',
    copySuffix: '(copia)',
    errorGeneric: 'No se pudo guardar la plantilla',
    summaryHeader: 'Encabezado',
    summaryNumbering: 'Numeración',
    summaryFill: 'Guiones',
    summaryClosing: 'Cierre',
    yes: 'sí',
    off: 'no',
    sectionGeneral: 'General',
    sectionPage: 'Hoja y márgenes',
    sectionTypography: 'Tipografía',
    sectionHeaderFooter: 'Encabezado y pie',
    sectionNumbering: 'Numeración de páginas',
    sectionFill: 'Relleno de líneas cortas',
    sectionClosing: 'Fórmula de cierre',
    fieldName: 'Nombre',
    fieldDescription: 'Descripción',
    fieldPageFormat: 'Tamaño de hoja',
    fieldOrientation: 'Orientación',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    a4: 'A4',
    letter: 'Carta',
    legal: 'Oficio',
    fieldMarginTop: 'Superior (mm)',
    fieldMarginBottom: 'Inferior (mm)',
    fieldMarginLeft: 'Izquierdo (mm)',
    fieldMarginRight: 'Derecho (mm)',
    fieldFontFamily: 'Letra',
    fieldFontSize: 'Tamaño (pt)',
    fieldLineHeight: 'Interlineado',
    fieldTextAlign: 'Alineación',
    alignJustify: 'Justificado',
    alignLeft: 'Izquierda',
    alignCenter: 'Centro',
    alignRight: 'Derecha',
    fieldParagraphSpaceAfter: 'Tras párrafo (pt)',
    fieldHeaderEnabled: 'Encabezado en las hojas',
    fieldHeaderText: 'Texto del encabezado',
    fieldHeaderAlign: 'Alineación',
    fieldHeaderMode: 'En qué hojas',
    headerModeAll: 'Todas',
    headerModeFirst: 'Solo la primera',
    headerModeRest: 'Todas menos la primera',
    fieldHeaderFontSize: 'Tamaño del encabezado (pt; vacío = el del cuerpo)',
    fieldFooterEnabled: 'Pie de página',
    fieldFooterText: 'Texto del pie',
    fieldPageNumbering: 'Numerar páginas',
    fieldPageNumberFormat: 'Formato',
    numberFormatN: '1, 2, 3',
    numberFormatNdeM: 'Página 1 de N',
    numberFormat00n: '001, 002',
    fieldPageNumberStart: 'Empezar en',
    fieldPageNumberPosition: 'Posición',
    posFooterCenter: 'Pie, centrado',
    posFooterRight: 'Pie, derecha',
    posHeaderRight: 'Encabezado, derecha',
    fieldFillShortLines: 'Completar las líneas cortas con guiones',
    fieldFillChar: 'Carácter',
    fieldFillScope: 'Dónde',
    fillScopeParagraphEnd: 'Última línea de cada párrafo',
    fillScopeLine: 'Toda línea corta',
    fillScopeBlankOnly: 'Solo líneas vacías',
    fieldClosingEnabled: 'Agregar fórmula de cierre',
    fieldClosingHtml: 'Texto (HTML sencillo)',
    fieldClosingKeepTogether: 'Mantenerla junto al último párrafo (nunca sola en una hoja nueva)',
    variablesHint: 'Variables disponibles (clic para copiar):',
    previewTitle: "Vista previa",
    previewDocxBtn: "Word de muestra",
    previewDocxError: "No se pudo generar el Word de muestra",
    mirrorMakeEditable: "Editar como formato propio",
    mirrorSheetNote: "El documento sale tal cual es hoy",
    verifiedBadge: "Verificado",
    alreadyInMenu: "Ya en tu menú",
    detectSaveDirect: "Guardar tal cual",
    swipeForMore: "Desliza para ver más formatos →",
    orderFormatLabel: "Formato de salida",
    orderFormatHint: "Decide cómo sale la Opción 4. También puedes cambiarlo en Revisión, sin reprocesar.",
    previewRealLoading: "Generando vista real…",
    closingLangLabel: "Idioma de la fórmula de juramento",
    closingLangEs: "Tal como está escrita en la plantilla (sin traducir)",
    closingLangTarget: "Traducida al idioma de destino de la orden",
    smallMarginWarn: "Un margen menor de 10 mm puede cortarse al imprimir.",
    colEmpty: "Vacía",
    colText: "Texto",
    colPageNum: "Número de página",
    colTextPlaceholder: "Texto de la columna",
    colRemove: "Quitar",
    colAdd: "Añadir columna",
    colSwitchToColumns: "Construir por columnas (hasta 4)",
    fieldFooterRule: "Línea impresa sobre el pie",
    sectionRules: "Reglas del documento",
    fieldLineNumbering: "Numerar las líneas (formato judicial)",
    fieldLinesPerPage: "Líneas por página",
    fieldLineNumberRule: "Regla vertical",
    lineNumberingHint: "Los números se recalculan solos al editar el Word: van en la sección, nunca escritos como texto.",
    pinBtn: "Fijar",
    pinnedBadge: "Fijado",
    pinHint: "Lo fijado aparece al preparar una orden",
    addToMenuBtn: "Agregar a mi menú",
    deleteInUseConfirm: "Este formato se usó en {n} orden(es). Las órdenes ya entregadas no cambian. ¿Eliminarlo igualmente?",
    searchPlaceholder: "Buscar un formato…",
    catAll: "Todos",
    catGeneral: "General",
    catCertified: "Certificada",
    catCourt: "Tribunales",
    pickerNoPinned: "No tienes formatos fijados. Fija los que uses en Formatos para verlos aquí.",
    uploadWordBtn: "Subir tu Word",
    detectTitle: "Esto es lo que trae tu Word",
    detectReading: "Leyendo el archivo…",
    detectIntro: "Del archivo {file} se leyeron estas propiedades. Lo no encontrado se marca tal cual — nada se rellena a escondidas.",
    detectNotFound: "No encontrado",
    detectYes: "Sí",
    detectNo: "No",
    detectHint: "Al abrir el editor podrás completar lo que falte y ver el resultado en el papel, en vivo.",
    detectOpenEditor: "Abrir en el editor",
    detectFailed: "No se pudo leer el archivo. ¿Es un .docx de hasta 20 MB?",
    previewPageOf: "Página {n} de {m}",
    previewTabScreen: "Pantalla",
    previewTabWord: "Word",
    previewTabPdf: "PDF",
    previewAllMatch: "Pantalla, Word y PDF salen igual",
    previewSample1: "CERTIFICADO DE NACIMIENTO",
    previewSample2: "Certifico que la presente es traducción fiel del documento original que he tenido ante mí. El interesado nació en la ciudad indicada y sus datos constan en el registro correspondiente.",
    previewSample3: "Los datos del acta coinciden con los del documento presentado, y no se advierten enmiendas ni raspaduras en el original.",
    previewClosingSignature: "Firma y sello del traductor",
    previewPageBreak: "salto de página",
    mirrorNotice: "Espejo del original: este formato reproduce el documento tal cual sale hoy. La página, la tipografía y las reglas no se aplican.",
    saveBtn: 'Guardar',
    savingBtn: 'Guardando…',
    cancelBtn: 'Cancelar',
    backBtn: 'Volver',
    unsavedConfirm: 'Tienes cambios sin guardar. ¿Salir sin guardarlos?',
    savedOk: 'Guardado',
    unsavedTitle: 'Cambios sin guardar',
    unsavedStay: 'Quedarme',
    unsavedLeave: 'Salir sin guardar',
    variablesLangHint: "Las variables de idioma, mes y fecha se escriben solas en el idioma de destino de la traducción.",
    closingSignatureToggle: "Agregar firma y sello (imagen)",
    closingSignatureUpload: "Subir imagen de firma/sello",
    closingSignatureRemove: "Quitar imagen",
    createBtn: 'Crear',
    defaultCardLabel: 'Plantilla de formato predeterminada',
    defaultCardHint: "Actívala para que tus órdenes tengan además la Opción 4 con este formato",
    defaultNone: "Sin plantilla (no se genera la Opción 4)",
    defaultManageLink: 'Administrar plantillas',
    defaultSaved: 'Guardado',
    pickerLabel: 'Plantilla',
    pickerApplying: 'Aplicando…',
    pickerError: 'No se pudo aplicar la plantilla',
    pickerNone: "Original",
  },
  sidebar: {
    formatTemplates: 'Formato',
    hubspot: 'HubSpot',
    payments: 'Pagos',
    campaignCodes: 'Códigos',
    ambassadorApplications: 'Postulaciones de embajadores',
    ambassadors: 'Embajadores',
    applications: 'Postulaciones',
    invite: 'Invitar',
    ambassadorAccount: 'Cuenta de embajador',
    adminAccount: 'Panel de administración',
    ambassadorHome: 'Inicio',
    ambassadorReferrals: 'Mis referidos',
    ambassadorCommissions: 'Comisiones',
    ambassadorNetwork: 'Mi red',
    overview: 'Resumen',
    accounts: 'Cuentas',
    users: 'Usuarios',
    logs: 'Registros',
    waitlist: 'Waitlist',
    templates: 'Plantillas',
    analytics: 'Analíticas',
    dashboard: 'Panel',
    orders: 'Órdenes',
    team: 'Equipo',
    credits: 'Créditos',
    certificate: 'Certificado',
    settings: 'Ajustes',
    myTasks: 'Mis Tareas',
    myWorkspace: 'Mi Espacio',
    account: 'Cuenta',
    activity: 'Actividad',
    plans: 'Planes',
    features: 'Funciones',
    signOut: 'Cerrar sesión',
    closeSidebar: 'Cerrar barra lateral',
    openSidebar: 'Abrir barra lateral',
    accountMenu: 'Menú de cuenta',
    corpus: 'Glosario',
    myTerms: 'Mis Términos',
    companySettings: 'Empresa',
    companyDataDesc: 'Datos de la empresa de la cuenta',
    blog: 'Blog',
    landingPages: 'Landing Pages',
    navMenu: 'Menú navegación',
    glossary: 'Glosarios',
    siteCopy: 'Textos del sitio',
    seo: 'SEO',
    apiKeys: 'API Keys',
    support: 'Soporte',
    knowledge: 'Conocimiento',
    eventRegistrations: 'Sorteos / Eventos',
    content: 'Contenido',
    events: 'Eventos',
  },
  dashboard: {
    welcome: 'Bienvenido de nuevo',
    subtitle: 'Esto es lo que está pasando con tus órdenes hoy.',
    newOrder: 'Nueva Orden',
    lowCredits: 'Créditos bajos: {n} restantes',
    creditsBalance: 'Balance',
    ordersInProgress: 'Órdenes en progreso',
    completedOrders: 'Órdenes completadas',
    teamMembers: 'Miembros del equipo',
    available: 'Disponible',
    low: 'Bajo',
    active: 'Activo',
    recentOrders: 'Órdenes Recientes',
    viewAll: 'Ver todo',
    noOrdersYet: 'Sin órdenes aún',
    createFirstOrder: 'Crea tu primera orden',
    quickActions: 'Acciones Rápidas',
    uploadDocument: 'Subir Documento',
    startNewTranslation: 'Iniciar una nueva traducción',
    buyCredits: 'Comprar Créditos',
    addToBalance: 'Añadir a tu saldo',
    inviteTeam: 'Invitar Equipo',
    addTeamMembers: 'Agregar miembros al equipo',
    companyOverview: 'Resumen de la Empresa',
    thisMonth: 'este mes',
    totalOrders: 'Total de órdenes',
    inProgress: 'En progreso',
    completed: 'Completadas',
    recentActivity: 'Actividad Reciente',
    translation: 'Traducción',
    translationEdit: 'Edición de Traducción',
    lastActivity: 'Última actividad',
    noActivityYet: 'Sin actividad aún',
    pages: 'página(s)',
    topLanguages: 'Idiomas Principales',
    creditActivity: 'Actividad de Créditos',
    document: 'Documento',
    languages: 'Idioma',
    date: 'Fecha',
    ordersCount: 'órdenes',
    archivedCount: '{n} archivadas',
    prev: 'Anterior',
    next: 'Siguiente',
    noTransactions: 'Sin transacciones aún',
    status: 'Estado',
    ocrGenerated: 'OCR',
    ocrEdit: 'Edición OCR',
    download: 'Descarga',
    txTranslationCompleted: 'Orden {order}: Traducción completada ({pages} págs)',
    txCreditsPurchased: 'Créditos comprados',
    txCreditsRefunded: 'Créditos reembolsados',
    txCreditsAdjusted: 'Créditos ajustados',
    txAutoRecharge: 'Recarga automática',
  },
  statuses: {
    uploaded: 'Subido',
    processing: 'Procesando',
    ocrreview: 'Revisión OCR',
    translationreview: 'Revisión de Traducción',
    completed: 'Completado',
    cancelled: 'Cancelado',
    unknown: 'Desconocido',
  },
  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todo leído',
    noNotifications: 'Sin notificaciones aún',
    dismiss: 'Descartar',
  },
  time: {
    justNow: 'Justo ahora',
    minAgo: 'hace {n} min',
    hourAgo: 'hace {n} hora',
    hoursAgo: 'hace {n} horas',
    yesterday: 'Ayer',
    daysAgo: 'hace {n} días',
    mAgo: 'hace {n}m',
    hAgo: 'hace {n}h',
    dAgo: 'hace {n}d',
  },
  orders: {
    title: 'Órdenes',
    subtitle: 'Gestiona tus órdenes de traducción',
    newOrder: 'Nueva Orden',
    total: 'Total',
    uploaded: 'Subidas',
    inProgress: 'En Progreso',
    completed: 'Completadas',
    thisMonth: 'Este Mes',
    noOrdersFound: 'No se encontraron órdenes',
    tryAdjusting: 'Intenta ajustar tu búsqueda o filtros',
    createFirst: 'Crea tu primera orden de traducción para comenzar',
    order: 'Orden',
    document: 'Documento',
    type: 'Tipo',
    pagesCol: 'Páginas',
    creditsCol: 'Créditos',
    qualityCol: 'Calidad',
    languageCol: 'Idioma',
    status: 'Estado',
    createdBy: 'Creado Por',
    assignedTo: 'Asignado A',
    client: 'Cliente',
    date: 'Fecha',
    actions: 'Acciones',
    showing: 'Mostrando',
    of: 'de',
    image: 'Imagen',
    text: 'Texto',
    handwritten: 'Manuscrito',
    modeTranslate: 'Traducción',
    modeLayout: 'Maqueta',
    searchPlaceholder: 'Buscar por nombre de documento, creador, cliente o número de orden...',
    allStatus: 'Todos los Estados',
    allTypes: 'Todos los Tipos',
    allDocTypes: 'Tipo de documento',
    allWorkTypes: 'Tipo de trabajo',
    view: 'Ver',
    clearDates: 'Borrar fechas',
    verifiedBy: 'Verificado por',
    due: 'Entrega',
    open: 'Abrir',
    filterProjects: 'Proyectos',
    filterSingle: 'Órdenes sueltas',
    archived: 'Archivados',
    toSetUp: 'Por configurar',
    cancelled: 'Cancelada',
    completedOf: '{pct}% completado · {done} de {total}',
    moveToProject: 'Mover a un proyecto…',
    removeFromProject: 'Quitar del proyecto',
    notAssigned: 'Sin asignar',
    trash: 'Papelera',
    trashAction: 'Eliminar',
    trashConfirmTitle: '¿Mover a la papelera?',
    trashConfirmMessage: 'Desaparecerá de las listas, del tablero y de los proyectos para todo tu equipo. Podrás restaurarla desde la Papelera durante 7 días. No se borra ningún archivo ni dato.',
    trashConfirmButton: 'Mover a la papelera',
    restore: 'Restaurar',
    deletePermanently: 'Eliminar permanentemente',
    deletePermanentlyConfirmTitle: '¿Eliminar permanentemente?',
    deletePermanentlyConfirmMessage: 'Dejará de estar disponible para todo tu equipo, también en la Papelera. Esta acción no se puede deshacer.',
    emptyTrash: 'Vaciar papelera',
    emptyTrashConfirmTitle: '¿Vaciar la papelera?',
    emptyTrashConfirmMessage: 'Todas las órdenes de la papelera se eliminarán permanentemente y dejarán de estar disponibles para tu equipo. Esta acción no se puede deshacer.',
    trashNotice: 'Las órdenes en la papelera se eliminan permanentemente a los 7 días.',
    trashEmpty: 'La papelera está vacía',
    trashDaysLeft: 'Quedan {days} d',
    trashActionFailed: 'No se pudo completar la acción. Inténtalo de nuevo.',
    trashNoPermission: 'No tienes permiso para eliminar órdenes.',
    working: 'Procesando...',
    purgedBadge: 'Datos eliminados',
    archiveAction: 'Archivar',
    unarchiveAction: 'Desarchivar',
    archivedEmpty: 'No hay órdenes ni proyectos archivados',
    archiveFailed: 'No se pudo archivar la orden. Inténtalo de nuevo.',
    archivedBadge: 'Archivada',
  },
  projects: {
    createOrder: 'Crear orden',
    createOrderHint: 'Un solo documento',
    createProject: 'Crear proyecto',
    createProjectHint: 'Varios documentos del mismo cliente o caso',
    newProject: 'Nuevo proyecto',
    name: 'Nombre del proyecto',
    namePlaceholder: 'ej. Caso María Roldán',
    client: 'Cliente',
    clientPlaceholder: 'Nombre del cliente',
    reference: 'Referencia',
    referencePlaceholder: 'Tu propio consecutivo',
    dueDate: 'Fecha de entrega',
    addNote: '+ Añadir nota',
    notePlaceholder: 'Notas de este caso',
    defaults: 'Valores por defecto para cada documento',
    task: '¿Qué necesitas?',
    translation: 'Traducción',
    layout: 'Maquetación',
    decidePerDocument: 'Decidir por documento',
    assignProject: 'Asignar todo el proyecto a',
    dropFiles: 'Suelta archivos aquí o elige archivos',
    chooseFiles: 'Elegir archivos',
    createCta: 'Crear proyecto',
    creating: 'Creando…',
    pastDate: 'Esta fecha ya pasó.',
    afterProjectDue: 'Esto es posterior a la fecha del proyecto ({date}).',
    prepTitle: 'Preparación',
    addDocuments: 'Añadir documentos',
    addNDocuments: 'Añadir {n} documentos',
    languages: 'Idiomas',
    assignTo: 'Asignar a',
    apply: 'Aplicar',
    statusReady: 'Lista',
    statusToSetUp: 'Por configurar',
    createNOrders: 'Crear {n} órdenes',
    estimated: 'Estimado: {n} créditos',
    remainingPrep: 'Quedarán {n} documentos en preparación',
    archive: 'Archivar proyecto',
    archiveConfirm: '¿Archivar este proyecto? Puedes desarchivarlo después.',
    unarchive: 'Desarchivar',
    downloadZip: 'Descargar todo',
    setTaskToContinue: 'Define la tarea de cada documento para continuar',
    creditsForXN: 'Tienes créditos para {x} de {n} órdenes.',
    createX: 'Crear {x}',
    recharge: 'Añadir créditos',
    position: '#',
    auto: 'Auto',
    removePrep: '¿Quitar este documento de la preparación?',
  },
  teamPage: {
    title: 'Equipo',
    subtitle: 'Gestiona los miembros de tu equipo e invitaciones',
    inviteMember: 'Invitar Miembro',
    teamMembers: 'Miembros del Equipo',
    pendingInvites: 'Invitaciones Pendientes',
    noMembers: 'No hay miembros aún. Invita a alguien para comenzar.',
    owner: 'Propietario',
    active: 'Activo',
    inactive: 'Inactivo',
    remove: 'Eliminar',
    joined: 'Se unió',
    pendingInvitations: 'Invitaciones Pendientes',
    expires: 'Expira',
    sent: 'Enviado',
    link: 'Enlace',
    copied: 'Copiado',
    resend: 'Reenviar',
    cancel: 'Cancelar',
    teamRoles: 'Roles del Equipo',
    teamRolesDesc: 'Los miembros <strong>Team</strong> pueden crear y gestionar órdenes. Los <strong>Members</strong> pueden trabajar en órdenes asignadas. Solo los propietarios pueden invitar nuevos miembros y gestionar la facturación.',
    inviteTeamMember: 'Invitar Miembro del Equipo',
    invitationSent: 'Invitación Enviada',
    firstName: 'Nombre',
    lastName: 'Apellido',
    emailAddress: 'Correo Electrónico',
    sending: 'Enviando...',
    sendInvitation: 'Enviar Invitación',
    invitationSentTo: 'Invitación enviada a',
    inviteLink: 'Enlace de Invitación',
    shareLinkDesc: 'Comparte este enlace con la persona para unirse a tu equipo.',
    done: 'Listo',
    copy: 'Copiar',
    member: 'Miembro',
    role: 'Rol',
    status: 'Estado',
    email: 'Correo',
    removeTeamMember: 'Eliminar Miembro del Equipo',
    removeConfirmMsg: '¿Estás seguro de que deseas eliminar a <strong>{name}</strong> de tu equipo? Esta acción no se puede deshacer. El miembro perderá acceso a todos los recursos del equipo inmediatamente.',
    removeMember: 'Eliminar Miembro',
    thisMonth: 'Este Mes',
    roleOwner: 'Propietario',
    roleManager: 'Gerente',
    roleReviewer: 'Revisor',
    roleMember: 'Miembro',
    roleManagerDesc: 'Lleva el día a día de la cuenta',
    roleReviewerDesc: 'Ve y aprueba el trabajo del equipo',
    roleMemberDesc: 'Solo sus documentos y los asignados',
    whatWillTheyDo: '¿Qué hará en la cuenta?',
    permissionsHint: 'Permisos sobre TODA la cuenta, no solo sobre su propio trabajo: lo que esta persona edite lo verá todo el equipo. Solo se guarda lo que ajustes.',
    whatThisAllows: 'Qué alcanza este permiso',
    scopeDocsViewAll: 'Ve y asigna TODAS las órdenes de la empresa, no solo las suyas.',
    scopeDocsApprove: 'Aprueba y finaliza documentos de la cuenta, también los que no hizo él.',
    scopeDocsDelete: 'Entra a cualquier orden y elimina sus datos y archivos; no se recuperan.',
    scopeCorpusEdit: 'El corpus y los glosarios son de la empresa: sus cambios afectan las traducciones de todo el equipo.',
    scopeCertManage: 'Las plantillas de certificado son de la empresa: las usan todos los miembros.',
    scopeBilling: 'Ve el saldo y COMPRA créditos con el medio de pago de la empresa.',
    scopeTeam: 'Invita, activa/desactiva y edita a otros miembros de la cuenta.',
    scopeAccountEdit: 'Cambia los datos de la empresa (nombre, razón social, NIT, logo) para todos.',
    scopeLogs: 'Ve la actividad de TODOS los usuarios de la cuenta, no solo la suya.',
    adjustedBadge: 'Ajustado',
    permDocsViewAll: 'Ver y asignar todos los documentos',
    permDocsApprove: 'Aprobar y finalizar documentos',
    permDocsDelete: 'Eliminar documentos',
    permCorpusEdit: 'Editar corpus y glosarios',
    permCertManage: 'Editar plantillas de certificado',
    permBilling: 'Ver y comprar créditos',
    permTeam: 'Invitar y desactivar miembros',
    permAccountEdit: 'Editar datos de la empresa',
    permLogs: 'Ver bitácora de actividad',
    readOnlyBadge: 'Solo lectura',
    adjustedOne: 'ajustado',
    adjustedMany: 'ajustados',
    permCountOne: 'permiso',
    permCountMany: 'permisos',
    edit: 'Editar',
    editMemberTitle: 'Editar miembro',
    saveChanges: 'Guardar cambios',
    saving: 'Guardando...',
    readOnlyLabel: 'Solo lectura',
    readOnlyHint: 'Puede ver el trabajo del equipo, pero no modificarlo.',
  },
  creditsPage: {
    title: 'Créditos',
    subtitle: 'Gestiona tus créditos y facturación',
    availableBalance: 'Saldo Disponible',
    creditsInfo: 'créditos',
    usedThisMonth: 'Usados Este Mes',
    totalPurchased: 'Total Comprados',
    yourSubscription: 'Tu Suscripción',
    cancelSubscription: 'Cancelar Suscripción',
    currentPlan: 'Plan Actual',
    unknown: 'Desconocido',
    subscriptionEnds: 'Suscripción Termina',
    nextBillingDate: 'Próxima Fecha de Cobro',
    willNotRenew: 'No se renovará',
    paymentMethod: 'Método de Pago',
    change: 'Cambiar',
    card: 'Tarjeta',
    expiresDate: 'Expira',
    autoRenew: 'Auto-Renovación',
    on: 'Activado',
    off: 'Desactivado',
    updating: 'Actualizando...',
    subscriptionEndingSoon: 'Suscripción por terminar',
    subscriptionEndingDesc: 'Tu suscripción terminará el {date}. Reactiva para mantener tus beneficios.',
    reactivateNow: 'Reactivar Ahora',
    cancelSubscriptionQ: '¿Cancelar Suscripción?',
    cancelSubscriptionDesc: '¿Estás seguro de cancelar tu suscripción <strong>{plan}</strong>? Seguirás teniendo acceso hasta <strong>{date}</strong>.',
    keepSubscription: 'Mantener Suscripción',
    yesCancel: 'Sí, Cancelar',
    changePlanQ: '¿Cambiar Plan?',
    newPlan: 'Nuevo Plan',
    changePlanDesc: 'Tu plan actual <strong>{current}</strong> se mantiene hasta que pagues. Al confirmar el pago se cancela esa suscripción y empieza <strong>{new}</strong>.',
    changePlan: 'Cambiar Plan',
    alreadySubscribed: 'Ya Suscrito',
    alreadySubscribedDesc: 'Ya estás suscrito al plan <strong>{plan}</strong>.',
    gotIt: 'Entendido',
    autoRechargeCredits: 'Recarga Automática de Créditos',
    whenBalanceBelow: 'Cuando el Saldo Baje de',
    credits: 'créditos',
    rechargeAmount: 'Monto de Recarga',
    autoRecharge: 'Recarga Automática',
    willAdd: 'Agregará <strong>{amount} créditos</strong> cuando el saldo baje de <strong>{threshold}</strong>',
    autoRechargeDisabled: 'La recarga automática está desactivada',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    noPaymentMethod: 'Sin método de pago',
    addPaymentMethodFirst: 'Necesitas agregar un método de pago primero. Realiza una compra o suscríbete a un plan para habilitar la recarga automática.',
    addPaymentMethodForRenewal: 'Añadir método de pago para renovar',
    addPaymentMethodTitle: 'Añade un método de pago para renovar',
    addPaymentMethodForRenewalDesc:
      'Tu plan está activo en este periodo. Añade una tarjeta para que se pueda cobrar el próximo ciclo — no se te cobrará hoy.',
    pendingPaymentMethodStatus: 'Activo — falta método de pago',
    nextBillingAfterPaymentMethod: 'Cuando añadas una tarjeta',
    buyCreditPackages: 'Comprar Paquetes de Créditos',
    noPackagesAvailable: 'No hay paquetes de créditos disponibles',
    mostPopular: 'Más Popular',
    buyNow: 'Comprar Ahora',
    buyCustomAmount: 'Comprar Monto Personalizado',
    buyCustomDesc: '¿Necesitas un monto específico? Ingresa cuántos créditos quieres (1 crédito = $1 USD)',
    enterCreditsMin: 'Ingresa créditos (mín. 10)',
    subscriptionPlans: 'Planes de Suscripción',
    monthly: 'Mensual',
    yearly: 'Anual',
    saveUpTo: 'Ahorra hasta 20%',
    noPlansAvailable: 'No hay planes de suscripción disponibles',
    year: 'año',
    month: 'mes',
    orMonthly: 'o ${price}/mes facturado mensualmente',
    orYearly: 'o ${price}/año (ahorra {discount}%)',
    creditsIncluded: '{n} créditos',
    noCreditsIncluded: 'Sin créditos incluidos',
    imageBasedPages: 'Páginas Basadas en Imagen',
    creditPerPage: '1 crédito / página',
    imageBasedDesc: 'Documentos escaneados, imágenes, PDFs que requieren OCR',
    textBasedPages: 'Páginas Basadas en Texto',
    textBasedDesc: 'PDFs digitales y documentos con capas de texto',
    transactionHistory: 'Historial de Transacciones',
    noTransactions: 'Sin transacciones aún',
    noTransactionsFilter: 'Sin transacciones en este período',
    showLess: 'Ver menos',
    txFilterAll: 'Todo',
    txFilterToday: 'Hoy',
    txFilterWeek: 'Esta Semana',
    txFilterMonth: 'Este Mes',
    exportCSV: 'Exportar CSV',
    txCount: 'transacciones',
    txNet: 'Neto',
    purchased: 'Compró {n} créditos',
    used: 'Usó {n} créditos',
    subscriptionHelp: 'Los planes de suscripción otorgan una cantidad fija de créditos mensual o anualmente para procesar tus documentos. Estos créditos se añaden a tu saldo al inicio de cada período de facturación.',
    subscriptionHelpTitle: 'Sobre las Suscripciones',
    subscriptionHelpContent: 'Los planes de suscripción otorgan una cantidad fija de créditos que se añaden a tu saldo al inicio de cada período de facturación (mensual o anual). Estos créditos se pueden usar para procesar documentos mediante OCR, traducción y otros servicios.\n\nTu suscripción se renueva automáticamente en cada fecha de cobro. Puedes cancelar en cualquier momento y mantener el acceso hasta el final del período actual. Si necesitas más créditos de los que incluye tu plan, puedes comprar paquetes adicionales o activar la recarga automática.',
    autoRechargeHelp: 'La recarga automática añade créditos a tu saldo de forma inmediata cuando este baja de un límite definido, asegurando que nunca te quedes sin procesar documentos. Puedes ajustar tanto el límite como el monto de recarga.',
    autoRechargeHelpTitle: 'Sobre la Recarga Automática',
    autoRechargeHelpContent: 'La recarga automática monitorea tu saldo de créditos y compra créditos adicionales automáticamente cuando baja del límite que configuraste. Esto asegura el procesamiento ininterrumpido de documentos sin intervención manual.\n\nTú eliges dos valores: el saldo mínimo (cuándo recargar) y el monto de recarga (cuántos créditos añadir). Tu método de pago guardado se cobrará automáticamente cada vez que se active una recarga.',
    viewPlans: 'Ver Planes de Suscripción',
    close: 'Cerrar',
    redeemCode: 'Código promocional',
    redeemPlaceholder: 'Ingresa tu código',
    redeemApply: 'Aplicar',
    redeemApplying: 'Aplicando…',
    redeemSuccess: 'Código aplicado',
    redeemError: 'No se pudo aplicar el código',
    redeemHint: 'Canjea un código de campaña. El beneficio de compra se aplica solo en el checkout.',
    redeemPreviewTrial: '{c} créditos de bonificación',
    redeemPreviewDiscount: '{p}% de descuento en el precio del plan en Stripe',
    redeemPreviewDiscountMonths: ' durante {n} meses',
    redeemPreviewPurchase: 'x{x} créditos incluidos con el plan',
    redeemApplied: 'Ya canjeaste {code}',
    redeemAppliedDiscount: 'El {p}% de descuento ya está en el precio de los planes.',
    redeemAppliedMultiplier: 'Recibirás x{x} créditos incluidos cuando actives un plan.',
    redeemAppliedPacks: 'paquetes de créditos',
    redeemAppliedPlans: 'planes {plans}',
    redeemAppliedNone: 'Este código ya está en tu cuenta.',
    planCardCodeDiscount: 'Precio con tu código {code}: {p}% de descuento',
    planCardCodeMultiplier: 'Tu código {code} multiplica los créditos del plan x{x}',
  },
  paywall: {
    teamTitle: 'Equipo está incluido en el plan Team',
    teamMessage: 'Necesitas activar un plan Team para invitar miembros y gestionar tu equipo.',
    corpusTitle: 'Los glosarios están incluidos en el plan Team',
    corpusMessage: 'Necesitas activar un plan Team para crear conjuntos de términos y usarlos en las traducciones.',
    cta: 'Activar un plan Team',
    openingCheckout: 'Abriendo Stripe…',
  },
  planGate: {
    teamTitle: 'Activa un plan Team para usar Equipo',
    teamBody: 'El plan Gratis no incluye gestión de equipo. Elige Team para invitar miembros y colaborar.',
    activityTitle: 'Activa un plan Team para ver la actividad del equipo',
    activityBody: 'El plan Gratis no incluye el historial de actividad del equipo. Activa Team para desbloquearlo.',
    activateTeamCta: 'Activar plan Team',
    openingCheckout: 'Abriendo Stripe…',
    memberTitle: 'Tu equipo necesita un plan',
    memberBody: 'Esta cuenta está en plan Gratis. Pedile al administrador del equipo que adquiera un plan para que puedas seguir trabajando.',
  },
  settingsPage: {
    unsavedTitle: "Tienes cambios sin guardar",
    unsavedMessage: "Si sales ahora se perderán los cambios de esta pantalla.",
    unsavedSaveAndLeave: "Guardar y salir",
    unsavedLeave: "Salir sin guardar",
    unsavedStay: "Seguir aquí",
    personalInfo: 'Información Personal',
    personalInfoDesc: 'Información básica de la cuenta',
    whatsappAvailable: 'Disponible en WhatsApp',
    dateFormat: 'Formato de Fecha',
    dateFormatHint: 'Para la interfaz. Las certificaciones usan el formato del país de destino.',
    markerStyleLabel: 'Notación de elementos visuales',
    seccionEmpresa: 'Empresa',
    correoEmpresa: 'Correo de la empresa',
    telefonoEmpresa: 'Teléfono de la empresa',
    seccionEmpresaDesc: 'Datos de la empresa, compartidos por todo el equipo',
    seccionPerfil: 'Perfil',
    seccionPerfilDesc: 'Tus datos personales y preferencias',
    managedByAgency: 'Lo gestiona tu agencia',
    usarLaDeLaEmpresa: 'Usar la de la empresa',
    perfilNoCargado: 'No se pudo cargar tu perfil. Recarga la página antes de guardar.',
    markerStyleHint: 'Estilo del delimitador para logos, sellos y firmas en sus traducciones.',
    markerBrackets: 'Corchetes',
    markerBraces: 'Llaves',
    interfaceLanguage: 'Idioma de la Interfaz',
    legalName: 'Razón Social',
    legalNamePlaceholder: 'Razón social para facturas',
    taxId: 'Identificación Fiscal',
    taxIdHint: 'Para facturas corporativas',
    website: 'Sitio Web',
    jobTitle: 'Tu cargo',
    jobTitlePlaceholder: 'CEO, Gerente de proyectos...',
    linkedinCompanyPage: 'Página de LinkedIn de la empresa',
    preferredContactMethod: 'Método de contacto preferido',
    preferredContactNone: 'Sin preferencia',
    preferredContactCall: 'Llamada',
    emailVerifyBannerTitle: 'Verifica tu correo electrónico',
    emailVerifyBannerDesc: 'Confirma que este es tu correo:',
    emailVerifySendCode: 'Enviar código',
    emailVerifySending: 'Enviando…',
    emailVerifyCta: 'Verificar',
    emailVerifyVerifying: 'Verificando…',
    emailVerifyError: 'No se pudo enviar el código. Inténtalo de nuevo.',
    title: 'Ajustes',
    subtitle: 'Gestiona tu cuenta y preferencias',
    saveChanges: 'Guardar Cambios',
    saving: 'Guardando...',
    saved: '¡Guardado!',
    profile: 'Perfil',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo',
    accountSection: 'Cuenta',
    companyName: 'Nombre de Empresa',
    changeLogo: 'Cambiar Logo',
    uploadLogo: 'Subir Logo',
    uploading: 'Subiendo...',
    remove: 'Eliminar',
    notificationsSection: 'Notificaciones',
    orderStatusUpdates: 'Actualizaciones de estado de órdenes',
    orderStatusUpdatesDesc: 'Recibe notificaciones cuando cambie el estado de una orden',
    teamActivity: 'Actividad del equipo',
    teamActivityDesc: 'Notificaciones sobre acciones de miembros del equipo',
    lowCreditAlerts: 'Alertas de créditos bajos',
    lowCreditAlertsDesc: 'Alerta cuando los créditos bajen de 50',
    marketingEmails: 'Correos de marketing',
    marketingEmailsDesc: 'Consejos, actualizaciones y ofertas',
    timezone: 'Zona Horaria',
    timezoneDesc: 'Configura tu zona horaria para mostrar fechas y horas correctamente.',
    current: 'Actual',
    security: 'Seguridad',
    changePassword: 'Cambiar Contraseña',
    sessions: 'Sesiones',
    activeSession: '1 sesión activa',
    signOutAllDevices: 'Cerrar sesión en todos los dispositivos',
    billing: 'Facturación',
    currentPlan: 'Plan Actual',
    payAsYouGo: 'Pago por uso',
    noPlanActive: 'Sin plan activo',
    noPlanDesc: 'Contacta al administrador de tu empresa para acceder a un plan',
    noPlanDescFreelancer: 'Compra créditos para empezar a traducir',
    viewInvoices: 'Ver Facturas',
    changePasswordModal: 'Cambiar Contraseña',
    changePasswordDesc: 'Ingresa tu contraseña actual y elige una nueva.',
    currentPassword: 'Contraseña Actual',
    enterCurrentPassword: 'Ingresa contraseña actual',
    newPassword: 'Nueva Contraseña',
    minChars: 'Mín. 8 caracteres',
    confirmNewPassword: 'Confirmar Nueva Contraseña',
    confirmYourPassword: 'Confirma tu contraseña',
    changingPassword: 'Cambiando contraseña...',
    passwordChanged: '¡Contraseña Cambiada!',
    passwordChangedDesc: 'Tu contraseña ha sido cambiada exitosamente.',
    done: 'Listo',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    logoMaxSize: 'El logo debe ser menor a 5MB',
    logoFormatHint: 'JPG, PNG o WEBP. Máx. 5MB.',
    helpTitle: '¿Necesitas Ayuda?',
    helpDesc: 'Nuestro equipo está aquí para ayudarte con cualquier consulta.',
    helpEmail: 'Contactar Soporte',
    helpDocs: 'Documentación',
    privacyPolicy: 'Política de Privacidad',
    termsConditions: 'Términos y Condiciones',
    allRightsReserved: 'Todos los derechos reservados.',
    // Privacy & Data Retention
    privacyRetention: 'Privacidad y Retención de Datos',
    privacyRetentionDesc: 'Configura la eliminación automática de datos de órdenes completadas después de un período de retención.',
    retentionPolicy: 'Política de Retención',
    retentionPolicyDesc: 'Las órdenes completadas serán purgadas automáticamente después del período seleccionado. Se genera un certificado de eliminación firmado con KMS para cada purga.',
    retentionDisabled: 'Desactivado',
    retentionDays: '{n} días',
    retentionSaving: 'Guardando...',
    retentionSaved: '¡Guardado!',
    retentionNone: 'Sin auto-eliminación',
    retentionDay: '{n} día',
    retentionDaysLabel: '{n} días',
    retentionWarning: 'Cambiar la retención reprogramará todos los temporizadores de purga pendientes para órdenes completadas.',
    retentionImmediate: 'Inmediato',
    retentionImmediateWarning: 'Cuando una orden se completa, todos sus datos y archivos se eliminarán permanentemente de inmediato. Se generará un certificado de eliminación como comprobante.',
    retentionActive: 'Activa',
    retentionInactive: 'Inactiva',
    deletionCertificates: 'Certificados de Eliminación',
    deletionCertificatesDesc: 'Ver certificados firmados criptográficamente para órdenes purgadas.',
    viewCertificates: 'Ver Certificados',
    noCertificates: 'Aún no hay certificados de eliminación.',
    downloadCertificate: 'Descargar PDF',
    previewCertificate: 'Vista Previa',
    // Timezone picker
    searchCity: 'Buscar ciudad...',
    noResults: 'Sin resultados',
    // Deletion certificate detail modal
    certDetail: {
      certificateOne: 'certificado',
      certificateMany: 'certificados',
      backToList: 'Volver a la lista',
      order: 'Orden',
      document: 'Documento',
      account: 'Cuenta',
      deletedAt: 'Eliminado el',
      method: 'Método',
      retention: 'Retención',
      retentionDaysTpl: '{n} días',
      integrity: 'Integridad',
      valid: 'Válido',
      invalid: 'Inválido',
      deletedFilesTpl: 'Archivos eliminados ({n})',
      purgedFieldsTpl: 'Campos eliminados ({n})',
      prev: 'Anterior',
      next: 'Siguiente',
    },
    professionalProfile: 'Perfil Profesional',
    professionalProfileDesc: 'Información utilizada en certificados y documentos oficiales',
    phone: 'Teléfono',
    phonePlaceholder: '+1234567890',
    phoneHint: 'Formato internacional (E.164)',
    address: 'Dirección',
    addressPlaceholder: 'Ciudad, Estado, País',
    association: 'Asociación Profesional',
    associationNoneOption: 'Ninguna',
    associationOther: 'Otra',
    associationCustomLabel: 'Nombre de la Asociación',
    certificationNumber: 'Número de Certificación / Membresía',
    languagePairs: 'Pares de Idiomas',
    languagePairsDesc: 'Idiomas de origen y destino que traduces',
    addLanguagePair: 'Agregar Par',
    sourceLanguage: 'Origen',
    targetLanguage: 'Destino',
    noLanguagePairs: 'Agrega al menos un par de idiomas',
    removePair: 'Eliminar',
    signatureImage: 'Imagen de Firma',
    signatureHint: 'JPG o PNG. Máx 2MB.',
    signatureInvalidFormat: 'La firma debe ser JPG o PNG',
    signatureMaxSize: 'La firma debe ser menor a 2MB',
    uploadSignature: 'Subir Firma',
    changeSignature: 'Cambiar',
    removeSignature: 'Eliminar',
    saveProfile: 'Guardar Perfil',
  },
  certificatePage: {
    title: 'Certificado',
    subtitle: 'Este certificado se añade automáticamente como última página de cada PDF traducido',
    uploadDocx: 'Subir .docx',
    newTemplate: 'Nueva Plantilla',
    editingTemplate: 'Editando plantilla de certificado',
    variables: 'Variables',
    saveAndClose: 'Guardar y Cerrar',
    saving: 'Guardando...',
    insertVariable: 'Insertar variable:',
    dynamicVariables: 'Variables Dinámicas',
    variablesDesc: 'Haz clic para copiar · Se reemplazan automáticamente en el certificado final',
    clickToCopy: 'Haz clic en cualquier variable para copiarla al portapapeles',
    hideExamples: 'Ocultar ejemplos',
    showExamples: 'Mostrar ejemplos',
    defaultTemplates: 'Plantillas Predeterminadas',
    myTemplates: 'Mis Plantillas',
    otherTemplates: 'Otras plantillas',
    setActive: 'Activar',
    active: 'Activo',
    global: 'Global',
    noTemplate: 'Sin plantilla de certificado',
    noTemplateDesc: 'Crea una para añadirla automáticamente a tus PDFs traducidos',
    createTemplate: 'Crear Plantilla',
    uploadTemplate: 'Subir Plantilla',
    name: 'Nombre',
    namePlaceholder: 'ej. Certificación de Exactitud',
    descriptionOptional: 'Descripción (opcional)',
    descriptionPlaceholder: 'Breve descripción de esta plantilla...',
    category: 'Categoría',
    general: 'General',
    legal: 'Legal',
    immigration: 'Inmigración',
    academic: 'Académico',
    cancel: 'Cancelar',
    creating: 'Creando...',
    createAndEdit: 'Crear y Editar',
    opening: 'Abriendo...',
    editTemplate: 'Editar Plantilla',
    activateHint: 'Activa una plantilla para agregarla a tu colección',
    templateLibrary: 'Biblioteca de Plantillas',
    willBeAppended: 'Este certificado se añadirá a todas las órdenes completadas',
    language: 'Idioma',
    anyLanguage: 'Cualquier idioma',
    english: 'Inglés',
    spanish: 'Español',
    portuguese: 'Portugués',
  },
  orderDetail: {
    backToOrders: 'Volver a Órdenes',
    continueOrder: 'Continuar Orden',
    error: 'Error',
    orderNotFound: 'Orden no encontrada',
    failedToLoad: 'Error al cargar la orden',
    orderDetails: 'Detalles de la Orden',
    documentType: 'Tipo de Documento',
    category: 'Categoría',
    sourceCountry: 'País de Origen',
    targetCountry: 'País de Destino',
    sourceLanguage: 'Idioma de Origen',
    targetLanguage: 'Idioma de Destino',
    totalPages: 'Total de Páginas',
    formatTemplate: 'Formato aplicado',
    noFormatTemplate: 'Original',
    credits: 'Créditos',
    consumed: 'consumidos',
    estimated: 'estimados',
    created: 'Creado',
    createdBy: 'Creado Por',
    assignedTo: 'Asignado A',
    completed: 'Completado',
    exportFormat: 'Formato de Exportación',
    originalFile: 'Archivo Original',
    view: 'Ver',
    openInNewTab: 'Abrir en nueva pestaña',
    download: 'Descargar',
    close: 'Cerrar',
    accessDenied: 'Acceso Denegado',
    adminNoAccess: 'Los administradores de la plataforma no pueden ver el contenido de los documentos por seguridad y privacidad. Solo los propietarios, miembros y freelancers pueden acceder a los documentos.',
    translatedDocument: 'Documento Traducido',
    finalDocument: 'Documento Maquetado',
    deletionCertificate: 'Certificado de Eliminación',
    translationCertificate: 'Certificado de Traducción',
    fileDeleted: 'Este archivo ha sido eliminado',
    sizeUnknown: 'Tamaño desconocido',
    uploadAndDetails: 'Subida y Detalles',
    ocr: 'OCR',
    review: 'Revisión',
    final: 'Final',
    deleteData: 'Eliminar Datos',
    deleteOrderData: 'Eliminar Datos de la Orden',
    deleteOrderDesc: 'Esto eliminará permanentemente todos los archivos (subidos y completados) de:',
    deleteOrderPreserved: 'El registro de la orden y el certificado de eliminación se conservarán. Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    dataDeletedSuccess: 'Datos eliminados exitosamente',
    dataDeletedFailed: 'Error al eliminar datos',
    certificateLabel: 'Certificado',
    // Human verification
    humanVerified: 'Verificado por Humano',
    verify: 'Verificar Traduccion',
    verifyConfirmTitle: 'Verificar Traduccion',
    verifyConfirmDesc: 'Estas certificando que esta traduccion fue revisada y aprobada por un traductor humano. Esta accion agregara un sello de verificacion al documento.',
    verifyNotes: 'Notas (opcional)',
    verifySuccess: 'Traduccion verificada exitosamente',
    verifyFailed: 'Error al verificar traduccion',
    verifiedBy: 'Verificado por',
    verifiedOn: 'Verificado el',
    viewVerification: 'Ver Verificacion Publica',
    // Data purged / deletion box
    dataPurged: 'Datos Eliminados',
    loadingCertificate: 'Cargando certificado...',
    allDataDeleted: 'Todos los archivos y datos sensibles han sido eliminados permanentemente.',
    filesDeletedTpl: '{n} archivos eliminados',
    autoPurgeNoticeTpl: 'Eliminación automática activada — Los archivos se eliminarán automáticamente {time} después de completarse',
    retentionMin: 'min',
    retentionHour: 'hora',
    retentionHours: 'horas',
    retentionDay: 'día',
    retentionDays: 'días',
    inTrashBanner: 'Esta orden está en la papelera. Se eliminará permanentemente el {date}.',
    restoreOrder: 'Restaurar orden',
    // Localized document type & category labels
    documentTypes: { image: 'Imagen', text: 'Texto', handwritten: 'Manuscrito' },
    categories: {
      birth_certificate: 'Acta de Nacimiento',
      certificate: 'Certificado',
      diploma: 'Diploma',
      passport: 'Pasaporte',
      marriage_license: 'Acta de Matrimonio',
      medical: 'Expediente Médico',
      legal: 'Documento Legal',
      immigration: 'Formulario de Inmigración',
      other: 'Otro',
    },
  },
  workspace: {
    title: 'Mi Espacio',
    welcomeBack: 'Bienvenido de nuevo, {name}. Tienes {n} tareas asignadas.',
    assigned: 'Asignado',
    tasksToComplete: 'Tareas por completar',
    active: 'Activo',
    inProgress: 'En progreso',
    completed: 'Completadas',
    thisMonth: 'Este mes',
    pendingTasks: 'Tareas Pendientes',
    pendingTasksDesc: 'Órdenes pendientes de tu revisión y procesamiento',
    noOrdersAssigned: 'Sin órdenes asignadas aún',
    ordersWillAppear: 'Las órdenes aparecerán aquí cuando sean asignadas a ti.',
    page: 'página',
    pages: 'páginas',
    workflowTip: 'Consejo de Flujo',
    workflowTipDesc: 'Cada orden sigue un flujo: <strong>Subida → Revisión OCR → Traducción → Completar</strong>. Debes verificar y aprobar cada paso antes de proceder al siguiente.',
    startOrder: 'Iniciar Orden',
    continueAction: 'Continuar',
    reviewAction: 'Revisar',
    viewAction: 'Ver',
    myOrders: 'Mis Órdenes',
    myOrdersSubtitle: 'Todas las órdenes asignadas a ti',
    searchPlaceholder: 'Buscar órdenes...',
    totalAssigned: 'Total Asignadas',
    noOrdersFound: 'No se encontraron órdenes',
    ordersAssignedAppear: 'Las órdenes asignadas aparecerán aquí.',
    document: 'Documento',
    pagesCol: 'Páginas',
    languages: 'Idiomas',
    status: 'Estado',
    createdCol: 'Creado',
    action: 'Acción',
    pageOf: 'Página {p} de {total}',
    orders: 'órdenes',
    creditPackages: 'Paquetes de Créditos',
    purchaseCreditsDesc: 'Compra créditos para procesar tus documentos',
    viewAll: 'Ver Todo',
    uploadPhoto: 'Subir Foto',
    managePreferences: 'Gestiona tus preferencias de cuenta',
    notifications: 'Notificaciones',
    newTaskAssignments: 'Nuevas asignaciones de tareas',
    newTaskAssignmentsDesc: 'Recibe notificaciones cuando se te asigne una nueva tarea',
    taskDeadlines: 'Fechas límite de tareas',
    taskDeadlinesDesc: 'Recordatorios de fechas límite próximas',
    commentsAndFeedback: 'Comentarios y retroalimentación',
    commentsAndFeedbackDesc: 'Notificaciones cuando alguien comente en tu trabajo',
    dailySummary: 'Resumen diario',
    dailySummaryDesc: 'Recibe un resumen diario de tus tareas',
    account: 'Cuenta',
    organization: 'Organización',
    role: 'Rol',
    yourStats: 'Tus Estadísticas',
    tasksCompleted: 'Tareas Completadas',
    pagesTranslated: 'Páginas Traducidas',
    avgQualityScore: 'Puntuación Promedio',
  },
  newOrder: {
    loadingOrder: 'Cargando orden...',
    restoreProgress: 'Por favor espera mientras restauramos tu progreso',
    stepProgress: 'Paso {step} de {total}',
    stepUploadDetails: 'Subida y Detalles',
    stepProcessing: 'Procesamiento',
    stepReview: 'Revisión',
    stepTranslation: 'Traducción',
    stepDownload: 'Descargar',
    modeLabel: 'Modo',
    modeTranslate: 'Traducir',
    modeLayout: 'Maquetar',
    modeTranslateHint: 'Traduce el documento a otro idioma, con certificación.',
    modeLayoutHint: 'Solo maquetación: reconstruye el documento en su idioma original, sin traducir.',
    layoutReadyTitle: 'Documento listo',
    layoutReadyDesc: 'Tu documento maquetado está listo para descargar en su idioma original.',
    downloadDocument: 'Descargar documento',
    preparingDownload: 'Preparando…',
    error: 'Error',
    uploadDocument: 'Subir Documento',
    acceptedFileTypes: 'PDF, Word (DOC, DOCX), JPG, PNG, TIFF, WebP',
    analyzingDocument: 'Analizando documento...',
    classifyingDocument: 'Clasificando documento...',
    loadingPreview: 'Cargando vista previa...',
    fileTypePdf: 'PDF',
    fileTypeWord: 'Word',
    docxTooLargeToCount: 'Muy grande para contar páginas — revísalas',
    fileTypeImage: 'Imagen',
    page: 'página',
    pages: 'páginas',
    hasText: 'Tiene texto',
    scanned: 'Escaneado',
    fileAnalysis: 'Análisis de Archivo',
    complete: 'Completo',
    textLabel: 'Texto:',
    selectable: 'Seleccionable',
    methodLabel: 'Método:',
    ocrMethod: 'OCR (1 cr/pág)',
    directMethod: 'Directo (1 cr/pág)',
    paperLetter: "Carta",
    paperA4: "A4",
    paperLegal: "Oficio",
    paperPortrait: "vertical",
    paperLandscape: "horizontal",
    handwritten: 'Manuscrito',
    mixedContent: 'Mixto (impreso + manuscrito)',
    disableHandwritten: 'Clic para procesar como imagen escaneada',
    enableHandwritten: 'Clic para restaurar modo manuscrito',
    manuscriptSuggestionTitle: 'Esto parece una imagen escaneada',
    manuscriptSuggestionBody: 'Para el resultado más limpio, usa el Modo Manuscrito. Convierte tu documento en texto claro y editable, con un diseño fiel al original. Si lo omites, el texto se coloca sobre la imagen escaneada, se ve más tosco y es más difícil de editar.',
    manuscriptSuggestionConfirm: 'Usar Modo Manuscrito',
    manuscriptSuggestionDismiss: 'Continuar sin usarlo',
    manuscriptSuggestionBadge: 'Recomendado',
    pageFormat: 'Formato de hoja',
    pageFormatLetter: 'Carta',
    pageFormatLegal: 'Oficio',
    orientationLabel: 'Orientación',
    orientationPortrait: 'Vertical',
    orientationLandscape: 'Horizontal',
    orientationSuggested: 'sugerida',
    readAloud: 'Leer',
    stopReading: 'Detener',
    loadingAudio: 'Cargando...',
    viewTranscript: 'Ver transcripción',
    transcriptTitle: 'Texto transcrito',
    copyText: 'Copiar',
    transcribingHandwriting: 'Transcribiendo texto manuscrito...',
    readingHandwriting: 'Leyendo texto manuscrito con IA...',
    processingPages: 'Procesando páginas...',
    generatingDocument: 'Generando documento...',
    clientName: 'Nombre del Cliente',
    clientNamePlaceholder: 'ej., Juan Pérez',
    reference: 'Referencia',
    dueDate: 'Fecha de entrega',
    addInstructions: '+ Agregar instrucciones',
    detailsSection: 'Detalles',
    languagesSection: 'Idiomas y localización',
    teamSection: 'Equipo',
    documentName: 'Nombre del Documento',
    documentNamePlaceholder: 'ej., Acta de Nacimiento - García',
    documentCategory: 'Categoría del Documento',
    sourceCountry: 'País de Origen',
    targetCountry: 'País de Destino',
    sourceLanguage: 'Idioma de Origen',
    targetLanguage: 'Idioma de Destino',
    chooseTargetLanguage: 'Elige el idioma de destino',
    targetLanguageRequired: 'Elige el idioma de destino para continuar',
    autoDeleteLabel: 'Eliminar archivos automáticamente después',
    autoDeleteAccountDefault: 'Usar por defecto de la cuenta',
    autoDeleteImmediate: 'Inmediato',
    autoDelete20min: '20 minutos',
    autoDelete1h: '1 hora',
    autoDelete6h: '6 horas',
    autoDelete1d: '1 día',
    autoDelete7d: '7 días',
    autoDelete30d: '30 días',
    autoDelete90d: '90 días',
    estimatedCredits: 'Créditos Estimados',
    creditCalculation: '{pages} página(s) x 1 crédito(s)',
    assignToTeamMember: 'Asignar a Miembro del Equipo',
    notAssigned: 'Sin asignar',
    notesInstructions: 'Notas / Instrucciones',
    teamNotesPlaceholder: 'Añadir instrucciones para el miembro del equipo asignado...',
    assigning: 'Asignando...',
    analyzing: 'Analizando...',
    assignNotify: 'Asignar y Notificar',
    questionOnPage: 'Hoja',
    questionNoPosition: 'sin ubicar',
    fileTooLargeDetail: 'El documento pesa {size} y el máximo son {max}. Divídelo en partes o compártelo con menos peso y vuelve a intentarlo.',
    unsupportedFileDetail: 'Formatos admitidos: PDF, Word (.doc, .docx) e imágenes (JPG, PNG, TIFF, WEBP).',
    uploadingOriginal: 'Subiendo el documento…',
    uploadFailedMessage: 'La orden se creó y se asignó, pero el documento no se pudo subir. Reintenta la subida; si vuelve a fallar, revisa tu conexión.',
    retryUpload: 'Reintentar la subida',
    originalUploadFailed: 'No se pudo subir el archivo. Revisa tu conexión e inténtalo de nuevo.',
    originalIncomplete: 'El archivo no llegó completo. Vuelve a subirlo.',
    originalMissingTitle: 'Vuelve a elegir el archivo',
    originalMissingMessage: 'No encontramos el archivo de esta orden. Elige de nuevo «{name}» ({size}) para continuar; lo demás que elegiste se conserva.',
    originalMissingShort: 'Esta orden no tiene su archivo. Vuelve a elegirlo para continuar.',
    originalDamaged: 'No pudimos leer el archivo: parece dañado o protegido con contraseña. Guárdalo de nuevo sin contraseña y vuelve a subirlo.',
    originalDifferentFile: 'Ese no es el archivo de esta orden, así que se empieza una orden nueva con él.',
    originalCopyPendingTitle: 'Copia del original pendiente',
    originalCopyPending: 'No pudimos guardar una copia del original; seguimos con tu documento y reintentaremos guardarla.',
    startOrder: 'Iniciar Orden',
    analyzeContinue: 'Analizar y Continuar',
    documentPreview: 'Vista Previa del Documento',
    wordDocument: 'Documento Word',
    contentPreview: 'Vista previa del contenido:',
    noPreviewAvailable: 'Sin vista previa disponible',
    processing: 'Procesando...',
    resumingProcessing: 'Reanudando procesamiento...',
    convertingDocument: 'Convirtiendo documento...',
    generatingPreview: 'Generando vista previa...',
    editDocument: 'Editar Documento',
    viewOriginal: 'Ver Original',
    saving: 'Guardando...',
    backToReview: 'Volver a Revisión',
    originalDocument: 'Documento Original',
    back: 'Atrás',
    exitOrderTitle: '¿Salir de la orden?',
    exitOrderMessage: 'Volverás a la lista de órdenes. Tu progreso queda guardado — podés retomar esta orden cuando quieras.',
    exitOrderConfirm: 'Sí, salir',
    exitOrderCancel: 'Continuar con la orden',
    documentReview: 'Revisión del Documento',
    of: 'de',
    stopAutoscroll: 'Detener auto-scroll',
    autoscroll: 'Auto-scroll',
    translating: 'Traduciendo...',
    loadingOriginal: 'Cargando original...',
    loadingShort: 'Cargando...',
    downloadDocx: 'Descargar DOCX',
    closeOrderTitle: '¿Terminar la orden?',
    closeOrderDesc: 'Ya descargaste el documento maquetado. Puedes dar la orden por terminada aquí mismo, sin pasar a traducción, para que no quede abierta.',
    closeOrderYes: 'Terminar orden',
    closeOrderNo: 'Seguir en la orden',
    closeOrderFailed: 'No se pudo terminar la orden. Inténtalo de nuevo.',
    closeOrderSaving: 'Guardando el documento…',
    reflowPagesBtn: 'Reacomodar hojas',
    reflowPagesError: 'No se pudieron reacomodar las hojas. Intenta de nuevo.',
    rotatePage: "Rotar documento",
    prevPage: "Página anterior",
    nextPage: "Página siguiente",
    dropHere: "Arrastra y suelta tu documento aquí",
    clickBrowse: "o haz clic para buscarlo en tu computador",
    selectFile: "Seleccionar archivo",
    supportedLabel: "Compatibles",
    progressMessages: {
      "Converting PDF to editable format...": "Convirtiendo el PDF a formato editable\u2026",
      "Creating order...": "Creando la orden\u2026",
      "Loading manuscript...": "Cargando el manuscrito\u2026",
      "Loading order...": "Cargando la orden\u2026",
      "Loading preview...": "Cargando la vista previa\u2026",
      "Resuming processing...": "Reanudando el procesamiento\u2026",
      "Generating preview...": "Generando la vista previa\u2026",
      "Converting document...": "Convirtiendo el documento\u2026",
      "Preparing document...": "Preparando el documento\u2026",
      "Converting document to base64...": "Preparando el archivo\u2026",
      "Applying crop...": "Aplicando el recorte\u2026",
      "Saving order details...": "Guardando los detalles\u2026",
      "Uploading file to cloud storage...": "Subiendo el archivo\u2026",
      "Analyzing document structure...": "Analizando la estructura\u2026",
      "Complete! Loading results...": "\u00a1Listo! Cargando resultados\u2026",
      "Finalizing...": "Finalizando\u2026",
      "Almost ready...": "Casi listo\u2026",
      "Exporting images and formats...": "Exportando im\u00e1genes y formatos\u2026",
      "Analyzing document...": "Analizando el documento\u2026",
      "OCR complete! Deducting credits...": "OCR completo, descontando cr\u00e9ditos\u2026",
      "Processing complete! Loading results...": "Procesamiento completo, cargando\u2026",
      "Extracting text and formatting...": "Extrayendo texto y formato\u2026",
      "Detecting document styles...": "Detectando los estilos\u2026",
      "Analyzing paragraphs...": "Analizando p\u00e1rrafos\u2026",
      "Merging text blocks...": "Uniendo bloques de texto\u2026",
      "Optimizing layout...": "Optimizando el dise\u00f1o\u2026",
      "Finalizing document structure...": "Finalizando la estructura\u2026",
      "OCR complete, assembling result...": "OCR completo, armando el resultado\u2026",
      "Deducting credits, almost ready...": "Descontando cr\u00e9ditos, casi listo\u2026",
    } as Record<string, string>,
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    fitToWidth: 'Ajustar al ancho',
    pdfPreviewError: 'No se pudo cargar la vista previa del PDF',
    continueToTranslation: 'Continuar a Traducción',
    panelOriginal: 'ORIGINAL',
    panelPreview: 'VISTA PREVIA',
    edit: 'Editar',
    previewNotAvailable: 'Vista previa no disponible',
    ocrResultsComparison: 'Resultados OCR - Comparación Visual',
    textBlocksDetected: 'bloques de texto detectados',
    accuracy: 'precisión',
    backToComparison: 'Volver a Comparación',
    editTranslation: 'Editar Traducción',
    translation: 'Traducción',
    panelTranslation: 'TRADUCCIÓN',
    updatingPreview: 'Actualizando vista previa...',
    translationPreviewNotAvailable: 'Vista previa de traducción no disponible',
    finishOrder: 'Finalizar Orden',
    orderCompleted: '¡Orden Completada!',
    orderDownloaded: 'Tu documento traducido ha sido descargado.',
    orderDownloadedLayout: 'Tu documento maquetado ha sido descargado.',
    redirecting: 'Redirigiendo...',
    finishOrderDesc: 'Descargar y completar esta traducción',
    finishOrderDescLayout: 'Descargar tu documento maquetado',
    document: 'Documento',
    exportFormat: 'Formato de exportación',
    formatPdf: 'PDF',
    formatOdt: 'ODT (texto editable)',
    translationLabel: 'Traducción',
    autoLanguage: 'Auto',
    creditsToCharge: 'Créditos a cobrar',
    creditsCharged: 'Créditos usados',
    currentBalanceLabel: 'Saldo actual: {balance} créditos. Descontados al iniciar la revisión OCR.',
    credits: 'créditos',
    creditBalance: 'Tu saldo: {balance} créditos. Después de completar: {remaining} créditos.',
    cancel: 'Cancelar',
    downloadComplete: 'Descargar y Completar',
    insufficientCredits: 'Créditos Insuficientes',
    insufficientCreditsDesc: 'Esta orden necesita {required} créditos y actualmente tienes {available}. Para completarla, compra más créditos o mejora tu plan.',
    creditsNeeded: 'Créditos necesarios:',
    yourBalance: 'Tu saldo:',
    shortfall: 'Faltante:',
    buyCredits: 'Comprar Créditos',
    upgradePlan: 'Mejorar Plan',
    bestValue: 'Mejor opción',
    contactOwner: 'Contacta al propietario de tu cuenta para agregar más créditos.',
    preparingTexts: 'Preparando textos para traducción...',
    translatingBlocks: 'Traduciendo {count} bloques...',
    applyingTranslations: 'Aplicando traducciones...',
    includeCertificate: 'Incluir Certificado',
    savingDocument: 'Guardando documento...',
    autosavePending: 'Cambios sin guardar',
    autosaveSaving: 'Guardando…',
    autosaveSaved: 'Guardado',
    autosaveError: 'No se pudo guardar, reintentando',
    editorCountWord: 'palabra',
    editorCountWords: 'palabras',
    editorCountChar: 'carácter',
    editorCountChars: 'caracteres',
    editorCountNoSpaces: 'caracteres sin espacios',
    translatingProgress: 'Traduciendo... ({completed}/{total})',
    generatingTranslatedPreview: 'Generando vista previa...',
    finalizingTranslation: 'Finalizando...',
    yes: 'Sí',
    no: 'No',
    protectPdf: 'Firma digital y protección',
    protectPdfHint: 'Desactívalo si firmarás con tu token',
    outputOptions: 'Opciones de salida',
    certificateTemplate: 'Certificado',
    selectTemplate: 'Seleccionar plantilla',
    noTemplates: 'No hay plantillas en esta categoría',
    addTemplate: 'Gestionar plantillas',
    humanVerifiedSeal: 'Sello Human Verified',
    attachOriginal: 'Adjuntar documento original',
    attachOriginalHint: 'Añade el archivo subido al principio o al final de la traducción',
    attachOriginalPosition: 'Posición del original',
    attachOriginalAtStart: 'Al principio',
    attachOriginalAtEnd: 'Al final',
    downloadPdf: 'Descargar PDF',
    downloadDoc: 'Descargar DOC',
    reviewDocument: 'Revisar Documento',
    chooseFormat: 'Elige el formato',
    optionWord: 'Opción 1',
    optionHtml: 'Opción 2',
    optionMix: 'Opción 3',
    optionFormat: 'Opción 4',
    optionFormatHint: 'Opción 2 con la plantilla de formato de la orden',
    optionFormatImages: 'imágenes',
    docHeaderLabel: 'ENCABEZADO DEL DOCUMENTO — se repetirá en cada página del Word/PDF',
    docFooterLabel: 'PIE DE PÁGINA DEL DOCUMENTO — se repetirá en cada página del Word/PDF',
    panelTranscription: 'TRANSCRIPCIÓN',
    hideEditorToolbar: 'Ocultar barra de edición',
    showEditorToolbar: 'Mostrar barra de edición',
    verifyDocumentTitle: 'Verificar documento',
    verifyDocumentDesc: 'Revisa el documento original a la izquierda y confirma los campos a la derecha',
    verificationLabel: 'Verificación',
    correctionPlaceholder: 'Escribe la corrección aquí...',
    detectedLabel: 'Detectado',
    hidePin: 'Ocultar marcador en el documento',
    showPin: 'Mostrar marcador en el documento',
    editedIndicator: 'Editado',
    skip: 'Omitir',
    confirm: 'Confirmar',
    localizationNoticeTitle: 'Adaptar fechas y cifras al país de destino',
    localizationNoticeIntro: 'País de destino: {country}. Allí las fechas y las cifras se escriben de otra forma: podemos ajustarlas para que se lean con naturalidad.',
    localizationNoticeSummaryTpl: 'Detectamos {items}.',
    localizationNoticeSummaryAnd: 'y',
    localizationNoticeDatesOne: '1 fecha',
    localizationNoticeDatesMany: '{n} fechas',
    localizationNoticeFiguresOne: '1 cifra',
    localizationNoticeFiguresMany: '{n} cifras',
    localizationNoticeExamplesTitle: 'Así quedarían',
    localizationNoticeChecking: 'Revisando fechas y cifras…',
    localizationNoticeMoreTpl: 'y {n} apariciones más',
    localizationNoticeTimesMany: '{n} veces',
    localizationNoticeTypeDate: 'Fecha',
    localizationNoticeTypeFigure: 'Cifra',
    localizationNoticeSafeTitle: 'Nada de esto se toca:',
    localizationNoticeSafeBody: 'los números de documento de identidad, de ley, de expediente y de teléfono se copian cifra por cifra, tal como están en el original.',
    localizationNoticeAdapt: 'Adaptar',
    localizationNoticeKeep: 'Dejar como el original',
    localizationNoticeRemember: 'No volver a preguntar en esta cuenta',
    localizationNoticeRememberHint: 'Tu elección queda como preferencia predeterminada de la cuenta.',
    localizationNoticeClose: 'Cerrar',
  },
  certVars: {
    translatorName: 'Nombre del Traductor',
    translatorNameDesc: 'Nombre completo del traductor/persona asignada',
    translatorEmail: 'Email del Traductor',
    translatorEmailDesc: 'Email del traductor/persona asignada',
    requesterName: 'Nombre del Solicitante',
    requesterNameDesc: 'Nombre de quien cre\u00f3 la orden',
    certificationDate: 'Fecha de Certificaci\u00f3n',
    certificationDateDesc: 'Fecha de la certificaci\u00f3n',
    orderDate: 'Fecha de Orden',
    orderDateDesc: 'Fecha en que se cre\u00f3 la orden',
    completionDate: 'Fecha de Finalizaci\u00f3n',
    completionDateDesc: 'Fecha en que se complet\u00f3 la orden',
    sourceLanguage: 'Idioma de Origen',
    sourceLanguageDesc: 'Idioma original del documento',
    targetLanguage: 'Idioma de Destino',
    targetLanguageDesc: 'Idioma destino de la traducci\u00f3n',
    sourceCountry: 'Pa\u00eds de Origen',
    sourceCountryDesc: 'Pa\u00eds del documento original',
    targetCountry: 'Pa\u00eds de Destino',
    targetCountryDesc: 'Pa\u00eds destino de la traducci\u00f3n',
    documentTitle: 'T\u00edtulo del Documento',
    documentTitleDesc: 'Nombre del documento',
    documentType: 'Tipo de Documento',
    documentTypeDesc: 'Categor\u00eda del documento',
    originalFile: 'Archivo Original',
    originalFileDesc: 'Nombre del archivo original subido',
    pageCount: 'Cantidad de P\u00e1ginas',
    pageCountDesc: 'N\u00famero de p\u00e1ginas traducidas',
    orderNumber: 'N\u00famero de Orden',
    orderNumberDesc: 'Solo el id de la orden (ej. RR0124-1). No se combina con el del proyecto.',
    projectNumber: 'N\u00famero de Proyecto',
    projectNumberDesc: 'Referencia personalizada del proyecto si existe, si no el nombre del proyecto',
    companyName: 'Nombre de Empresa',
    companyNameDesc: 'Nombre de la empresa/agencia de traducci\u00f3n',
    orderNotes: 'Notas de la Orden',
    orderNotesDesc: 'Notas adjuntas a la orden',
    translatorPhone: 'Teléfono del Traductor',
    translatorPhoneDesc: 'Número de teléfono del perfil del traductor',
    associationName: 'Asociación',
    associationNameDesc: 'Asociación profesional (ATA, NAJIT, etc.)',
    certificationNumber: 'Número de Certificación',
    certificationNumberDesc: 'Número de certificación o membresía profesional',
    languagePairs: 'Pares de Idiomas',
    languagePairsDesc: 'Pares de idiomas del traductor (ej. Inglés → Español)',
    translatorAddress: 'Dirección del Traductor',
    translatorAddressDesc: 'Dirección completa del perfil del traductor',
    translatorCity: 'Ciudad',
    translatorCityDesc: 'Ciudad de la dirección del traductor',
    translatorState: 'Estado',
    translatorStateDesc: 'Estado/provincia de la dirección del traductor',
    translatorCountry: 'País',
    translatorCountryDesc: 'País de la dirección del traductor',
    translatorZip: 'Código Postal',
    translatorZipDesc: 'Código postal de la dirección del traductor',
  },
  auth: {
    invalidCredentials: 'Correo o contraseña incorrectos',
    userExists: 'Ya existe una cuenta con este correo',
    accountDeactivated: 'Tu cuenta ha sido desactivada. Contacta a tu administrador.',
    accountLocked: 'Cuenta bloqueada temporalmente. Inténtalo de nuevo en {n} minuto(s).',
    tooManyAttemptsLocked: 'Demasiados intentos fallidos. Cuenta bloqueada por {n} minutos.',
    verifyEmailTitle: 'Verifica tu email',
    verifyEmailDesc: 'Enviamos un código de 6 dígitos a',
    verifyEmailCta: 'Verificar y continuar',
    verifyEmailWrong: '¿Email incorrecto? Volver',
    welcomeBack: 'Bienvenido de nuevo',
    signInSubtitle: 'Inicia sesión para continuar a tu panel',
    createAccount: 'Crea tu cuenta',
    startFreeTrial: 'Comienza tu prueba gratuita hoy',
    firstName: 'Nombre',
    firstNamePlaceholder: 'María',
    lastName: 'Apellido',
    lastNamePlaceholder: 'García',
    registerAsCompany: 'Registrar como empresa',
    companyName: 'Nombre de la empresa',
    companyNamePlaceholder: 'Nombre de tu empresa',
    companyLogo: 'Logo de la Empresa',
    emailAddress: 'Correo electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    password: 'Contraseña',
    passwordPlaceholder: 'Mín. 8 caracteres',
    enterPassword: 'Ingresa tu contraseña',
    signIn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    creatingAccount: 'Creando cuenta...',
    uploadingLogo: 'Subiendo logo...',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes una cuenta?',
    createAnAccount: 'Crear una cuenta',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    signInLink: 'Iniciar sesión',
    continueWithGoogle: 'Continuar con Google',
    continueWithLinkedIn: 'Continuar con LinkedIn',
    orEmailPassword: 'o continuar con',
    oauthFailed: 'No se pudo entrar con esa cuenta. Inténtalo de nuevo.',
    oauthGoogleOriginError: 'Google rechazó este origen ({origin}). En Google Cloud Console → Credenciales → cliente Web, añadí exactamente esa URL en «Orígenes de JavaScript autorizados». Si el Client ID es de Android/iOS o está mal, también da Error 401.',
    authFailed: 'Error de autenticación',
    connectionError: 'Error de conexión. Inténtalo de nuevo.',
    tooManyRequests: 'Demasiados intentos. Espera unos minutos antes de volver a intentarlo.',
    sessionError: 'Error al crear la sesión',
    // Password requirements
    pwdMinLength: 'Mínimo 8 caracteres',
    pwdUppercase: 'Al menos una letra mayúscula',
    pwdLowercase: 'Al menos una letra minúscula',
    pwdNumber: 'Al menos un número',
    pwdSpecialChar: 'Al menos un carácter especial (!@#$%^&*)',
    pwdStrengthWeak: 'Débil',
    pwdStrengthFair: 'Regular',
    pwdStrengthGood: 'Buena',
    pwdStrengthStrong: 'Fuerte',
    // Forgot password
    forgotPasswordTitle: 'Restablecer contraseña',
    forgotPasswordDesc: 'Ingresa tu correo y te enviaremos un código de verificación.',
    sendCode: 'Enviar Código',
    sendingCode: 'Enviando...',
    verificationCode: 'Ingresa el código de verificación',
    verificationCodeDesc: 'Hemos enviado un código de 6 dígitos a',
    verifyCode: 'Verificar Código',
    verifyingCode: 'Verificando...',
    resendCode: 'Reenviar código',
    resendIn: 'Reenviar en {n}s',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Confirma tu contraseña',
    resetPassword: 'Establecer contraseña',
    resettingPassword: 'Restableciendo...',
    passwordResetSuccess: '¡Contraseña Restablecida!',
    passwordResetSuccessDesc: 'Tu contraseña ha sido cambiada exitosamente. Ya puedes iniciar sesión con tu nueva contraseña.',
    backToSignIn: 'Volver a Iniciar Sesión',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    // Inactivity
    sessionExpired: 'Sesión expirada',
    sessionExpiredDesc: 'Tu sesión se cerró por inactividad. Por favor inicia sesión de nuevo.',
    // Success
    accountCreatedSuccess: '¡Cuenta creada exitosamente! Por favor inicia sesión.',
    // Auth page chrome + mockup
    backToHome: 'Volver al inicio',
    mockupTitleOrders: 'Gestioná todas tus órdenes',
    mockupDescOrders: 'Seguí documentos, idiomas y estados en un solo lugar.',
    mockupTitleEditor: 'Editor de traducción con IA',
    mockupDescEditor: 'Revisión OCR en paralelo con traducción en tiempo real.',
    mockupTitleTeam: 'Diseñado para equipos y empresas',
    mockupDescTeam: 'Gestioná traductores, revisores y administradores juntos.',
    mockupTitleCredits: 'Créditos y facturación a la vista',
    mockupDescCredits: 'Monitoreá el uso, comprá créditos y seguí tus gastos.',
    mockupTabOrders: 'Órdenes',
    mockupTabEditor: 'Editor',
    mockupTabTeam: 'Equipo',
    mockupTabCredits: 'Créditos',
    mockupNavOrders: 'Órdenes',
    mockupNavWorkspace: 'Espacio',
    mockupNavTeam: 'Equipo',
    mockupNavCredits: 'Créditos',
    mockupNavSettings: 'Ajustes',
    mockupHeaderOrders: 'Órdenes',
    mockupHeaderWorkspace: 'Espacio de trabajo',
    mockupHeaderCompanyDashboard: 'Panel de la empresa',
    mockupHeaderCreditsBilling: 'Créditos y facturación',
    mockupSearchOrders: 'Buscar órdenes...',
    mockupNewOrder: '+ Nueva orden',
    mockupColDocument: 'Documento',
    mockupColLanguage: 'Idioma',
    mockupColStatus: 'Estado',
    mockupColDate: 'Fecha',
    mockupStatusCompleted: 'Completada',
    mockupStatusInReview: 'En revisión',
    mockupStatusProcessing: 'Procesando',
    mockupStatusPending: 'Pendiente',
    mockupStepUpload: 'Subir',
    mockupStepOcr: 'OCR',
    mockupStepReview: 'Revisar',
    mockupStepExport: 'Exportar',
    mockupOriginalLabel: 'Original (ES)',
    mockupTranslationLabel: 'Traducción (EN)',
    mockupTotalOrders: 'Órdenes totales',
    mockupTeamMembers: 'Miembros del equipo',
    mockupThisMonth: 'Este mes',
    mockupTeamActivity: 'Actividad del equipo',
    mockupRoleTranslator: 'Traductor',
    mockupRoleReviewer: 'Revisor',
    mockupRoleAdmin: 'Admin',
    mockupRowOrders: 'órdenes',
    mockupAvailableCredits: 'Créditos disponibles',
    mockupProPlan: 'Plan Pro',
    mockupBusinessPlan: 'Plan Empresa',
    mockupRecentTransactions: 'Transacciones recientes',
    mockupCredits: 'créditos',
  },
  activityPage: {
    title: 'Actividad del Equipo',
    subtitle: 'Rastrea en qué están trabajando los miembros de tu equipo',
    exportCSV: 'Exportar CSV',
    totalActivities: 'Total de Actividades',
    clients: 'Clientes',
    ocrOperations: 'Operaciones OCR',
    translations: 'Traducciones',
    searchPlaceholder: 'Buscar por nombre de miembro, ID de orden, nombre de cliente...',
    allActions: 'Todas las Acciones',
    ocrGenerated: 'OCR Generado',
    ocrEdited: 'OCR Editado',
    translationGenerated: 'Traducción Generada',
    translationEdited: 'Traducción Editada',
    downloadAction: 'Descarga',
    statusCompleted: 'Estado Completado',
    member: 'Miembro',
    time: 'Hora',
    order: 'Orden',
    action: 'Acción',
    details: 'Detalles',
    loading: 'Cargando actividad...',
    noActivity: 'No se encontró actividad',
    showing: 'Mostrando',
    of: 'de',
    total: 'total',
    orderCreated: 'Orden Creada',
    ocrCompleted: 'OCR Completado',
    translationGen: 'Traducción Gen',
    translationEdit: 'Traducción Edit',
    processing: 'Procesando',
    completed: 'Completado',
    translationReview: 'Revisión Traducción',
    ocrReview: 'Revisión OCR',
    orderAssigned: 'Tarea Asignada',
    tasksAssigned: 'Tareas Asignadas',
    allMembers: 'Todos los Miembros',
    client: 'Cliente',
    noClient: 'N/A',
    clearDates: 'Limpiar fechas',
    role: 'Rol',
    orderTrashed: 'Enviada a la papelera',
    orderRestored: 'Restaurada de la papelera',
    orderArchived: 'Archivada',
    orderUnarchived: 'Desarchivada',
    orderDeleted: 'Eliminada permanentemente',
    orderDeletedAuto: 'Eliminada permanentemente (automático, 7 días)',
    trashEmptied: 'Papelera vaciada',
  },
  corpus: {
    title: 'Mis Términos',
    subtitle: 'Gestiona tus términos de traducción por idioma y categoría.',
    folders: 'Carpetas',
    createFolder: 'Nueva Carpeta',
    createCorpus: 'Nuevo Set de Términos',
    createError: 'No se pudo crear el set de términos. Inténtalo de nuevo.',
    glossary: 'Términos',
    documents: 'Documentos',
    style: 'Estilo',
    knowledge: 'Base de Conocimiento',
    sourceTerm: 'Término Origen',
    targetTerm: 'Término Destino',
    context: 'Contexto / Notas',
    addTerm: 'Agregar Término',
    importCsv: 'Importar CSV',
    exportCsv: 'Exportar CSV',
    importPreview: 'Vista previa',
    importConfirm: 'Importar',
    importSuccess: 'importados',
    importDuplicates: 'duplicados omitidos',
    importErrors: 'errores',
    importTotal: 'entradas totales',
    importDragOrClick: 'Arrastra un archivo CSV aquí o haz clic para buscar',
    importCsvFormat: 'Formato: source_term, target_term, context (encabezado opcional)',
    importing: 'Importando...',
    export: 'Exportar',
    terms: 'términos',
    noCorpus: 'Sin términos aún',
    selectCorpus: 'Seleccionar Set de Términos',
    formal: 'Formal',
    neutral: 'Neutral',
    plain: 'Sencillo',
    noFolders: 'Sin carpetas aún. Crea una para organizar tus términos.',
    noEntries: 'Sin términos aún. Agrega tu primer término.',
    search: 'Buscar...',
    name: 'Nombre',
    description: 'Descripción',
    sourceLanguage: 'Idioma Origen',
    targetLanguage: 'Idioma Destino',
    customInstructions: 'Instrucciones personalizadas',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    active: 'Activo',
    inactive: 'Inactivo',
    corpora: 'Sets de Términos',
    folder: 'Carpeta',
    back: 'Volver',
    create: 'Crear',
    showing: 'Mostrando',
    of: 'de',
    noResults: 'Sin resultados',
    confirmDeleteFolder: '¿Eliminar esta carpeta? Los sets de términos dentro se moverán a "Sin carpeta".',
    confirmDeleteCorpus: '¿Eliminar este set de términos y todas sus entradas? Esta acción no se puede deshacer.',
    confirmDeleteTerm: '¿Eliminar este término?',
    prev: 'Anterior',
    next: 'Siguiente',
    comingSoonMilestone: 'Disponible pronto',
    folderPlaceholder: 'Legal, Médico, Académico...',
    corpusNamePlaceholder: 'Certificados Legales ES→EN',
    instructionsPlaceholder: 'Ej: Usar "usted" en vez de "tú". Mantener formato de fechas DD/MM/YYYY...',
    noFolder: 'Sin carpeta',
    color: 'Color',
    whatIsCorpus: '¿Qué son Mis Términos?',
    whatIsCorpusDesc: 'Tu biblioteca personal de términos. Agrega términos, documentos de ejemplo y reglas de estilo para que la IA traduzca usando tu vocabulario.',
    corpusInFolder: 'sets de términos en esta carpeta',
    shared: 'Compartido',
    category: 'Categor\u00eda',
    writingStyle: 'Estilo de escritura',
    formalDesc: 'Vocabulario técnico preciso, oraciones estructuradas.',
    neutralDesc: 'Equilibrio entre formalidad y accesibilidad.',
    plainDesc: 'Oraciones cortas, vocabulario simple.',
    createNewCorpus: 'Crear nuevo set de términos',
    configureDesc: 'Configura tu biblioteca de referencia y agrega tu contenido.',
    corpusNameRequired: 'Nombre del set de términos *',
    corpusNameExample: 'Ej: Penalista, Cardiología, Transcripts...',
    corpusUseDesc: 'Para qué vas a usar este set de términos',
    exampleDocs: 'Documentos ejemplo',
    exampleDocsDesc: 'Sube traducciones anteriores tuyas como referencia de estilo y formato.',
    originalDoc: 'Original',
    translatedDoc: 'Traducción',
    docPairTip: 'Tendrás mejores resultados si subes el par completo (original + traducción). Puedes subir solo uno.',
    knowledgeDesc: 'Artículos, guías o material de consulta que la IA usará como referencia al traducir.',
    uploadArticle: 'Subir artículo',
    acceptedFormats: 'Formatos aceptados: PDF, DOCX, TXT. Máximo 10 MB por archivo.',
    dragFileHere: 'Arrastra tu archivo aquí',
    tmxCsvFormat: 'TMX, CSV o Excel (Col A = original, Col B = traducción)',
    addManually: 'agrega términos manualmente',
    generateAI: 'Generar con IA',
    share: 'Compartir',
    viewTabs: 'Pestañas',
    viewScroll: 'Lista',
    unorganized: 'Sin carpeta',
    add: 'Agregar',
    styleExtracted: 'Estilo extraído',
    noDocuments: 'Aún no hay documentos de ejemplo. Sube un par para mejorar la precisión.',
    noKnowledge: 'Aún no hay artículos. Sube material de referencia para la IA.',
    articles: 'artículos',
    uploadPair: 'Subir par',
    notes: 'Notas',
    found: 'encontrados',
    sourceColumn: 'Origen',
    targetColumn: 'Destino',
    removeFile: 'Quitar',
    glossaryFileError: 'Formato no admitido. Sube el glosario en Excel, CSV, TSV o TMX.',
    glossarySpreadsheetError: 'Ese formato de hoja de cálculo no se puede leer. Ábrelo y guárdalo como .xlsx o CSV; después súbelo.',
    glossaryTooManyTerms: 'El archivo tiene {count} términos y el máximo por archivo son 100.000. Divídelo en varios archivos.',
    glossaryEmptyError: 'No se encontraron entradas válidas en el archivo.',
    docFileError: 'Sube un archivo de texto (PDF, DOCX, TXT).',
    knowledgeFileError: 'Sube un archivo de texto (PDF, DOCX, TXT).',
    fileTooLarge: 'El archivo debe ser menor a 10 MB.',
    uploadingGlossary: 'Importando glosario...',
    uploadingDocuments: 'Subiendo documentos...',
    uploadingKnowledge: 'Subiendo',
    quickStartTitle: 'Cómo funciona',
    step1Title: '1. Crea un Glosario',
    step1Desc: 'Agrega tus términos de glosario (CSV, TSV o TMX) para que la IA use tus traducciones preferidas.',
    step2Title: '2. Agrega documentos de ejemplo',
    step2Desc: 'Sube documentos previamente traducidos para que la IA aprenda tu estilo y tono.',
    step3Title: '3. Traduce',
    step3Desc: 'Selecciona tu glosario al crear una orden. Tus términos se aplicarán automáticamente.',
  },
  admin: {
    translationEngines: {
      header: 'Motores de traducción',
      subtitle: 'Controla qué motores traducen los documentos. Se aplica en el servidor: el motor se cambia o bloquea de verdad, no solo se oculta en la interfaz.',
      tab: 'Traducción',
      deeplLabel: 'DeepL',
      deeplDesc: 'Permite traducir con DeepL (traducción automática rápida, sin glosarios de corpus). Aplica solo cuando el pedido NO tiene corpus.',
      claudeLabel: 'Claude',
      claudeDesc: 'Permite traducir con Claude para pedidos SIN corpus (traducción consciente del contexto).',
      corpusLabel: 'Corpus → siempre Claude',
      corpusDesc: 'Fijo (no configurable): un pedido con corpus siempre se traduce con Claude — los glosarios de corpus solo pueden ejecutarse con Claude.',
      alwaysOn: 'Siempre activo',
      bothDisabled: 'Ambos motores están desactivados — los pedidos SIN corpus se quedarán sin motor. (Los pedidos con corpus igual se traducen con Claude.)',
      effectiveTitle: 'Comportamiento efectivo',
      effectiveWithCorpus: 'Con corpus: solo Claude (corpus) — siempre, aunque el interruptor de Claude esté apagado.',
      effectiveWithoutCorpusPrefix: 'Sin corpus:',
      noneEnabled: 'ninguno activo',
    },
    orderDetail: {
      back: 'Volver',
      documentInfo: 'Información del documento',
      category: 'Categoría',
      type: 'Tipo',
      pages: 'Páginas',
      step: 'Paso',
      exportFormat: 'Formato de exportación',
      certificate: 'Certificado',
      digitalSignature: 'Firma digital',
      humanVerified: 'Verificado por humano',
      attachOriginal: 'Adjuntar original',
      originalFile: 'Archivo original',
      translation: 'Traducción',
      sourceLanguage: 'Idioma de origen',
      targetLanguage: 'Idioma de destino',
      sourceCountry: 'País de origen',
      targetCountry: 'País de destino',
      translationMethod: 'Método de traducción',
      people: 'Personas',
      account: 'Cuenta',
      createdBy: 'Creado por',
      creditsAndDates: 'Créditos y fechas',
      creditsEstimated: 'Créditos estimados',
      creditsConsumed: 'Créditos consumidos',
      created: 'Creado',
      updated: 'Actualizado',
      completed: 'Completado',
      processingTime: 'Tiempo de procesamiento',
      platformCostBreakdown: 'Desglose de costos de la plataforma',
      service: 'Servicio',
      usage: 'Uso',
      costUsd: 'Costo (USD)',
      total: 'Total',
      yes: 'Sí',
      no: 'No',
      mode: 'Modo',
      referenceNumber: 'Referencia',
      clientName: 'Cliente',
      dueDate: 'Fecha de entrega',
      verificationId: 'ID de verificación',
      viewVerification: 'Ver verificación pública',
      humanVerifiedBy: 'Verificado por',
      translationApprovedBy: 'Traducción aprobada por',
      filesPurgedTpl: 'Archivos purgados el {date}',
      deletionCertificateLink: 'Ver certificado de eliminación',
    },
    common: {
      systemOnline: 'Sistema en línea',
      allTime: 'Desde siempre',
      realTime: 'En tiempo real',
      search: 'Buscar',
      save: 'Guardar',
      cancel: 'Cancelar',
      create: 'Crear',
      edit: 'Editar',
      delete: 'Eliminar',
      close: 'Cerrar',
      done: 'Listo',
      loading: 'Cargando...',
      saving: 'Guardando...',
      success: 'Éxito',
      error: 'Error',
      confirmDelete: '¿Eliminar este elemento? Esta acción no se puede deshacer.',
      cannotBeUndone: 'Esta acción no se puede deshacer.',
      actions: 'Acciones',
      status: 'Estado',
      name: 'Nombre',
      description: 'Descripción',
      title: 'Título',
      category: 'Categoría',
      type: 'Tipo',
      date: 'Fecha',
      language: 'Idioma',
      active: 'Activo',
      inactive: 'Inactivo',
      draft: 'Borrador',
      total: 'Total',
      page: 'Página',
      of: 'de',
      previous: 'Anterior',
      next: 'Siguiente',
      showing: 'Mostrando',
      noResults: 'Sin resultados',
      allStatus: 'Todos los estados',
      exportCSV: 'Exportar CSV',
      view: 'Ver',
      add: 'Agregar',
      remove: 'Quitar',
      refresh: 'Actualizar',
      copy: 'Copiar',
      copied: 'Copiado',
      select: 'Seleccionar',
      applying: 'Aplicando...',
    },
    overview: {
      title: 'Panel de administración',
      subtitle: 'Resumen y gestión del sistema',
      totalOrders: 'Órdenes totales',
      activeAccounts: 'Cuentas activas',
      totalUsers: 'Usuarios totales',
      creditsBalance: 'Saldo de créditos',
      humanVerified: 'Verificado por humanos',
      totalRevenue: 'Ingresos totales',
      today: 'Hoy',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      platformCostsAllTime: 'Costos de plataforma (histórico)',
      totalCost: 'Costo total',
      avgPerOrder: 'Prom. / orden',
      avgPerPage: 'Prom. / página',
      ordersProcessed: 'Órdenes procesadas',
      totalPages: 'Páginas totales',
      costByService: 'Costo por servicio',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Document AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      ocrExtraction: 'Extracción OCR',
      ocrComplementary: 'OCR complementario',
      visionPostEdit: 'Visión + Post-edición',
      translation: 'Traducción',
      pages: 'Páginas',
      costPerPage: 'Costo/página',
      ocrColor: 'OCR (color)',
      visionClass: 'Visión (clas.)',
      postEdit: 'Post-edición',
      characters: 'Caracteres',
      words: 'Palabras',
      costPerMillion: 'Costo/1M chars',
      detailedUsage: 'Desglose detallado de uso',
      service: 'Servicio',
      purpose: 'Propósito',
      usage: 'Uso',
      cost: 'Costo (USD)',
      ocrTextExtraction: 'OCR extracción de texto',
      ocrColorDetection: 'OCR detección de color',
      visionClassification: 'Clasificación de visión',
      translationPostEdit: 'Post-edición de traducción',
      totalPlatformCost: 'Costo total de plataforma',
      tokens: 'tokens',
      chars: 'chars',
      topLanguagePairs: 'Pares de idiomas principales',
      ordersByStatus: 'Órdenes por estado',
      noLanguagePairData: 'Aún no hay datos de pares de idiomas',
      percentOfOrders: '% del total de órdenes',
      orders: 'órdenes',
      noOrderData: 'No hay datos de órdenes disponibles',
      totalOrdersLabel: 'Órdenes totales',
      activitySummary: 'Resumen de actividad',
      ordersToday: 'Órdenes hoy',
      creditsConsumed: 'Créditos consumidos',
      completed: 'completadas',
      inProgress: 'en progreso',
      totalAccounts: 'total',
      newThisWeek: 'esta semana',
      newThisMonth: 'nuevas este mes',
      verified: 'verificadas',
      ofCompleted: 'de',
      sold: 'vendidos',
      consumed: 'consumidos',
      creditsSold: 'Créditos vendidos',
      totalPurchased: 'Total comprado por clientes',
      unusedAcrossAccounts: 'Créditos sin usar en todas las cuentas',
      used: 'Usados',
      remaining: 'Restantes',
      available: 'Disponibles',
      balance: 'Saldo',
      imageBased: 'Basado en imagen',
      textBased: 'Basado en texto',
      documents: 'documentos',
      documentsByType: 'Documentos por tipo',
      pagesByType: 'Páginas por tipo de documento',
      imagePages: 'Páginas de imagen',
      textPages: 'Páginas de texto',
      noDocData: 'Aún no hay datos de documentos',
      noPageData: 'Aún no hay datos de páginas',
      activeUsers: 'activos',
      teamUsers: 'de equipo',
      memberUsers: 'miembros',
      statusUploaded: 'Subida',
      statusProcessing: 'Procesando',
      statusOcrReview: 'Revisión OCR',
      statusTranslationReview: 'Revisión de traducción',
      statusCompleted: 'Completada',
      plusTodayTpl: '+{n} hoy',
      plusThisWeekTpl: '+{n} esta semana',
    },
    accounts: {
      title: 'Cuentas',
      subtitle: 'Gestionar todas las cuentas registradas',
      searchPlaceholder: 'Buscar cuentas...',
      noAccountsFound: 'No se encontraron cuentas',
      account: 'Cuenta',
      owner: 'Propietario',
      members: 'Miembros',
      plan: 'Plan',
      credits: 'Créditos',
      created: 'Creada',
      payAsYouGo: 'Pago por uso',
      activate: 'Activar',
      suspend: 'Suspender',
      viewDetails: 'Ver detalles',
      addCredits: 'Agregar créditos',
      statusActive: 'Activa',
      statusTrial: 'Probando',
      statusSuspended: 'Suspendida',
      adjustCredits: 'Ajustar créditos',
      currentBalance: 'Saldo actual',
      creditsAmount: 'Cantidad de créditos',
      amountPlaceholder: 'Ej. 100 (usá negativo para descontar)',
      amountHint: 'Positivo para agregar, negativo para descontar',
      reason: 'Motivo',
      reasonPlaceholder: 'Ej. Créditos de cortesía, corrección de facturación...',
      newBalance: 'Nuevo saldo',
      creditsAppliedSuccess: 'créditos aplicados con éxito',
      failedToAdjust: 'No se pudieron ajustar los créditos',
      networkError: 'Error de red. Intentá de nuevo.',
      applyCredits: 'Aplicar créditos',
      applying: 'Aplicando...',
      showing: 'Mostrando',
      accountsLabel: 'cuentas',
      changePlan: 'Cambiar plan',
      noPlan: 'Sin plan',
      assignPlan: 'Asignar plan',
      selectPlan: 'Seleccioná un plan',
      billingCycle: 'Ciclo de facturación',
      monthly: 'Mensual',
      yearly: 'Anual',
      applyCreditsLabel: 'Sumar créditos del plan al saldo actual',
      currentPlan: 'Plan actual',
      newPlan: 'Plan nuevo',
      planChangedSuccess: 'Plan actualizado con éxito',
      failedToChangePlan: 'No se pudo cambiar el plan',
      freelanceOnly: 'Solo freelancer (1 miembro)',
      companyPlan: 'Plan company',
      removePlan: 'Quitar plan',
      memberLimitExceeded: 'La cuenta tiene más miembros que los permitidos por este plan',
      freeMembersKeepHint: 'Los miembros se quedan en la cuenta. Equipo quedará bloqueado hasta que compren un plan de pago.',
      freeCreditModeLabel: 'Créditos al pasar a Free',
      freeCreditKeepPlus5: 'Saldo actual + 5',
      freeCreditOnly5: 'Solo 5 (quitar el resto)',
      removePlanWarning: 'Se cancela la suscripción en Stripe de inmediato y el saldo pasa a 0.',
      ownerViewHint: 'El plan también ajusta lo que ve el dueño: con un plan de equipo pasa a la vista de equipo. El cambio se aplica la próxima vez que inicie sesión.',
      lastActive: 'Última actividad',
      never: 'Nunca',
      trialColumn: 'Prueba',
      trialExpired: 'Vencido',
      trialOneDay: '1 día',
      trialDays: n => `${n} días`,
    },
    users: {
      title: 'Usuarios',
      subtitle: 'Gestionar todos los usuarios de la plataforma',
      searchPlaceholder: 'Buscar usuarios por nombre o email...',
      user: 'Usuario',
      email: 'Email',
      accountLabel: 'Cuenta',
      userType: 'Tipo',
      role: 'Rol',
      lastLogin: 'Último acceso',
      status: 'Estado',
      noUsersFound: 'No se encontraron usuarios',
      allTypes: 'Todos los tipos',
      allRoles: 'Todos los roles',
      typeAdmin: 'Admin',
      typeTeam: 'Equipo',
      typeMember: 'Miembro',
      typeUser: 'Usuario',
      roleOwner: 'Propietario',
      roleAdmin: 'Admin',
      roleManager: 'Gerente',
      roleMember: 'Miembro',
      roleFreelancer: 'Freelancer',
      activate: 'Activar',
      deactivate: 'Desactivar',
      impersonate: 'Suplantar',
      viewActivity: 'Ver actividad',
      never: 'Nunca',
      showing: 'Mostrando',
      usersLabel: 'usuarios',
      subtitleActivity: 'Monitorea la actividad y el engagement de los usuarios',
      exportExcel: 'Exportar a Excel',
      exportEmail: 'Correo',
      exportPlan: 'Plan',
      exportCreditsAvailable: 'Créditos disponibles',
      exportConsumedAccount: 'Consumidos (cuenta)',
      exportConsumedUser: 'Consumidos (usuario)',
      onlineNow: 'En línea ahora',
      activeToday: 'Activos hoy',
      byRole: 'Por rol',
      teamShort: 'equipo',
      memberShort: 'miembro',
      userShort: 'usuario',
      allActivity: 'Toda la actividad',
      filterOnline: 'En línea ahora',
      filterRecent: 'Activo recientemente',
      filterActiveStatus: 'Estado: activo',
      filterSuspendedStatus: 'Estado: suspendido',
      statusOnline: 'En línea',
      statusRecently: 'Recientemente',
      statusOffline: 'Desconectado',
      statusSuspendedBadge: 'Suspendido',
      lastActive: 'Última actividad',
      lastPage: 'Última página',
      joined: 'Se unió',
      noAccount: 'Sin cuenta',
      moreAccountsTpl: '+{n} más',
      showingRangeTpl: 'Mostrando {from}-{to} de {total} usuarios',
      timeJustNow: 'justo ahora',
      timeMinAgoTpl: 'hace {n}m',
      timeHourAgoTpl: 'hace {n}h',
      timeDayAgoTpl: 'hace {n}d',
      timeWeekAgoTpl: 'hace {n}sem',
      platformAdminLabel: 'Admin de plataforma',
      platformAdminBadge: 'Admin de plataforma',
      platformAdminDescription: 'Da acceso a /admin sin cambiar su rol de equipo o plan. Pueden cambiar de vista como los embajadores.',
      platformAdminReloginHint: 'Deben cerrar sesión e iniciar sesión de nuevo para que el cambio surta efecto.',
      platformAdminGrant: 'Hacer admin de plataforma',
      platformAdminRevoke: 'Quitar admin de plataforma',
      platformAdminGranted: 'Admin de plataforma concedido',
      platformAdminRevoked: 'Admin de plataforma eliminado',
      platformAdminFailed: 'No se pudo actualizar el admin de plataforma',
      platformAdminConfirmGrant: '¿Conceder admin de plataforma a este usuario? Conserva su vista de equipo/plan y debe volver a iniciar sesión.',
      platformAdminConfirmRevoke: '¿Quitar el admin de plataforma a este usuario? Debe volver a iniciar sesión.',
    },
    orders: {
      title: 'Todas las órdenes',
      subtitle: 'Ver y gestionar todas las órdenes de todas las cuentas',
      searchPlaceholder: 'Buscar órdenes por número o nombre de documento...',
      totalOrders: 'Órdenes totales',
      completed: 'Completadas',
      inProgress: 'En progreso',
      totalPlatformCost: 'Costo total de plataforma',
      orderNum: 'Orden N°',
      document: 'Documento',
      account: 'Cuenta',
      pages: 'Páginas',
      credits: 'Créditos',
      quality: 'Calidad',
      cost: 'Costo (USD)',
      status: 'Estado',
      date: 'Fecha',
      actions: 'Acciones',
      viewBtn: 'Ver',
      logsBtn: 'Logs',
      noOrdersFound: 'No se encontraron órdenes.',
      platformCostBreakdown: 'Desglose de costo de plataforma',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Doc AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      grandTotal: 'Total general',
      allServicesCombined: 'todos los servicios combinados',
      detailedUsageBreakdown: 'Desglose detallado de uso',
      allTimeAggregated: 'Uso agregado histórico de todas las órdenes',
      service: 'Servicio',
      purpose: 'Propósito',
      usage: 'Uso',
      costUsd: 'Costo (USD)',
      ocrTextExtraction: 'OCR (extracción de texto)',
      ocrComplementary: 'OCR (complementario)',
      visionClassification: 'Visión (clasificación)',
      translationClaude: 'Traducción (Claude)',
      translation: 'Traducción',
      totalLbl: 'Total',
      orderLogsTitle: 'Logs de la orden',
      loadingLogs: 'Cargando logs...',
      noLogsFound: 'No hay logs para esta orden.',
      timestamp: 'Marca de tiempo',
      action: 'Acción',
      creditsCol: 'Créditos',
      pagesLower: 'páginas',
      charsLower: 'chars',
      tokensLower: 'tokens',
      statusUploaded: 'Subida',
      statusProcessing: 'Procesando',
      statusOcrReview: 'Revisión OCR',
      statusTranslationReview: 'Revisión de traducción',
      statusCompleted: 'Completada',
      allStatus: 'Todos los estados',
      actionOrderCreated: 'Orden creada',
      actionOcrCompleted: 'OCR completado',
      actionOcrGenerated: 'OCR generado',
      actionOcrEdited: 'OCR editado',
      actionTranslationGen: 'Trad. generada',
      actionTranslationEdit: 'Trad. editada',
      actionDownload: 'Descarga',
      actionProcessing: 'Procesando',
      actionCompleted: 'Completada',
      actionTranslationReview: 'Revisión de traducción',
      actionOcrReview: 'Revisión OCR',
      exportCSV: 'Exportar CSV',
      wordsLower: 'palabras',
      ordersLower: 'órdenes',
      showingRangeTpl: 'Mostrando {from}-{to} de {total} órdenes',
      orderLogsForTpl: 'Logs de la orden — {orderNumber}',
      visibilityAll: 'Visibilidad: todas',
      visibilityActive: 'Activas',
      visibilityTrash: 'En papelera',
      visibilityDeleted: 'Eliminadas permanentemente',
      visibilityArchived: 'Archivadas',
      badgeInTrash: 'En papelera',
      badgeDeleted: 'Eliminada permanentemente',
      deletedAuto: 'Automática (7 días en la papelera)',
      byTpl: '{date} · por {name}',
      inTrashSince: 'En papelera desde',
      statusCancelled: 'Cancelada',
      actorAuto: 'Automático',
      userCol: 'Usuario',
    },
    waitlist: {
      title: 'Lista de espera',
      subtitle: 'Registros de Founding User desde la landing page',
      totalSignups: 'Registros totales',
      companies: 'Empresas',
      wantBetaAccess: 'Quieren acceso beta',
      latestSignup: 'Último registro',
      searchPlaceholder: 'Buscar por nombre, email, empresa o rol...',
      noEntriesFound: 'No se encontraron registros en la lista',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      company: 'Empresa',
      role: 'Rol',
      pagesPerWeek: 'Pág./sem.',
      biggestPain: 'Mayor problema',
      priceWillingness: 'Disposición de pago',
      betaInterest: 'Interés beta',
      language: 'Idioma',
      signedUp: 'Registrado',
      signedUpAt: 'Registrado el',
      deleteEntry: 'Eliminar registro',
      viewDetails: 'Ver detalles',
      deleteConfirm: '¿Eliminar este registro?',
    },
    analytics: {
      title: 'Analíticas',
      subtitle: 'Rendimiento y perspectivas de la plataforma',
      totalOrders: 'Órdenes totales',
      activeAccounts: 'Cuentas activas',
      ordersProcessed: 'Órdenes procesadas',
      creditsConsumed: 'Créditos consumidos',
      ordersByStatus: 'Órdenes por estado',
      topLanguagePairs: 'Pares de idiomas principales',
      documentsByType: 'Documentos por tipo',
      pagesByDocType: 'Páginas por tipo de documento',
      imageBased: 'Basado en imagen',
      textBased: 'Basado en texto',
      imagePages: 'Páginas de imagen',
      textPages: 'Páginas de texto',
      documents: 'documentos',
      pages: 'páginas',
      noOrderData: 'Aún no hay datos de órdenes',
      noLanguagePairData: 'Aún no hay datos de pares de idiomas',
      noDocData: 'Aún no hay datos de documentos',
      noPageData: 'Aún no hay datos de páginas',
      statusUploaded: 'Subida',
      statusProcessing: 'Procesando',
      statusOcrReview: 'Revisión OCR',
      statusTranslationReview: 'Revisión de traducción',
      statusCompleted: 'Completada',
    },
    blog: {
      title: 'Blog · Artículos Ranqio',
      subtitle: 'Contenido ingestado vía API + edición de SEO, OG, JSON-LD y estado.',
      searchPlaceholder: 'Buscar por título...',
      allStatuses: 'Todos los estados',
      statusDraft: 'Borrador',
      statusScheduled: 'Programado',
      statusPublished: 'Publicado',
      statusArchived: 'Archivado',
      noArticles: 'No hay artículos.',
      titleCol: 'Título',
      status: 'Estado',
      locale: 'Locale',
      author: 'Autor',
      publishedAt: 'Publicado',
      actions: 'Acciones',
      viewOnSite: 'Ver en el sitio',
      editSeo: 'Editar SEO',
      deleteArticle: 'Eliminar',
      deleteConfirm: '¿Eliminar este artículo? Esta acción no se puede deshacer.',
      articles: 'artículos',
      pageOf: 'Página {p} de {t}',
      errorSave: 'Error al guardar.',
    },
    copy: {
      title: 'Textos del sitio',
      subtitle: 'Editá los textos de la landing principal en todos los idiomas. Los cambios viven en borrador hasta que apretás Publicar.',
      discardDraft: 'Descartar borrador',
      saveDraft: 'Guardar borrador',
      publish: 'Publicar',
      publishing: 'Publicando',
      draftSaved: '✓ Borrador guardado. No es visible al público todavía.',
      publishedMsg: '🚀 Publicado. Los visitantes ya ven los cambios.',
      errorSaveDraft: 'Error al guardar borrador',
      errorPublish: 'Error al publicar',
      discardConfirm: '¿Descartar borrador y volver a la versión publicada?',
      draftDiscarded: 'Borrador descartado',
      loadingError: 'Error cargando copy',
      unpublishedChanges: 'Hay cambios sin publicar en',
      pressPublish: 'Apretá Publicar para que los visitantes los vean.',
      unsaved: 'sin guardar',
      draftBadge: 'borrador',
      pendingChanges: 'Cambios sin publicar',
    },
    nav: {
      title: 'Menú de navegación',
      subtitle: 'Configurá los items del header. Podés crear enlaces a páginas, dropdowns con sub-items, o links externos.',
      newItem: 'Nuevo item',
      noItems: 'Todavía no hay items. Creá el primero para que aparezca en el header del sitio.',
      dragHint: '💡 Arrastrá los items por la manija de la izquierda para reordenarlos.',
      itemCreated: 'Item creado',
      itemUpdated: 'Item actualizado',
      saveError: 'Error al guardar',
      deleteConfirm: '¿Eliminar este item? Si tiene hijos también se eliminarán.',
      newItemTitle: 'Nuevo item',
      editItemTitle: 'Editar item',
      kind: 'Tipo',
      kindLink: 'Link externo (URL)',
      kindLanding: 'Landing page (creada en EZDocuAI)',
      kindDropdown: 'Dropdown (con sub-items)',
      url: 'URL',
      urlHint: 'Ej: https://docs.ejemplo.com o /pricing',
      landingPage: 'Landing page',
      landingHint: 'Si la landing se renombra o borra, el link se actualiza/desactiva automáticamente.',
      selectPlaceholder: '— Seleccionar —',
      parentItem: 'Item padre (opcional)',
      parentHint: 'Para anidar dentro de un dropdown',
      noParent: '— Sin padre (top-level) —',
      activeLabel: 'Activo (visible en el header)',
      addSubItem: 'Agregar sub-item',
      dragReorder: 'Arrastrar para reordenar',
      deleteItem: 'Eliminar',
      inactive: 'inactivo',
      items: 'items',
    },
    seo: {
      title: 'SEO y Metadatos',
      subtitle: 'Optimizá tu sitio para motores de búsqueda y redes sociales.',
      tabGeneral: 'General',
      tabRobots: 'Robots',
      tabSitemap: 'Sitemap',
      tabPages: 'Páginas',
      errorLoading: 'Error cargando configuración',
      settingsSaved: 'Configuración guardada',
      errorSaving: 'Error al guardar',
      saveChanges: 'Guardar cambios',
      addSocialProfile: 'Agregar perfil social',
      generalSection: 'Configuración general',
      siteName: 'Nombre del sitio',
      siteNamePlaceholder: 'EZDocuAI',
      siteUrl: 'URL del sitio',
      siteUrlPlaceholder: 'https://www.ezdocu.ai',
      titleTemplate: 'Plantilla de título',
      titleTemplateHint: 'Usá %s donde irá el título de cada página',
      titleTemplatePlaceholder: '%s | EZDocuAI',
      defaultTitle: 'Título por defecto',
      titleCounterLabel: 'Título',
      defaultDescription: 'Descripción por defecto',
      descriptionCounterLabel: 'Descripción',
      ogImage: 'Imagen para redes sociales (OG)',
      ogImageHint: 'Tamaño recomendado: 1200×630px. Subila desde tu máquina o pegá una URL.',
      ogImagePlaceholder: 'https://… o subí una imagen',
      googleVerification: 'Código de verificación de Google',
      googleVerificationPlaceholder: 'google-site-verification=...',
      socialProfiles: 'Perfiles sociales',
      socialProfilePlaceholder: 'https://www.instagram.com/ezdocu',
      googlePreview: 'Vista previa en Google',
      socialPreview: 'Vista previa en redes sociales',
      indexingSection: 'Indexación del sitio',
      allowGoogleIndex: 'Permitir que Google indexe el sitio',
      allowGoogleIndexHint: 'Si lo desactivás, el sitio no aparecerá en buscadores.',
      blockedPathsSection: 'Rutas bloqueadas para crawlers',
      blockedPathsHint: 'Estas rutas no serán rastreadas por Google ni otros buscadores.',
      blockedPathPlaceholder: '/ruta-a-bloquear/',
      aiPolicySection: 'Política de crawlers de IA',
      aiPolicyAllowAll: 'Permitir todos',
      aiPolicyAllowAllDesc: 'Google, Bing, ChatGPT, Claude pueden acceder',
      aiPolicyBlockTraining: 'Bloquear entrenamiento',
      aiPolicyBlockTrainingDesc: 'Permite búsqueda IA, bloquea entrenamiento (GPTBot, CCBot)',
      aiPolicyBlockAll: 'Bloquear todos los bots IA',
      aiPolicyBlockAllDesc: 'Solo permite buscadores tradicionales',
      robotsPreviewSection: 'Vista previa de robots.txt',
      sitemapSection: 'Configuración del sitemap',
      autoGenerateSitemap: 'Generar sitemap automáticamente',
      autoGenerateSitemapHint: 'Incluye páginas estáticas, landing pages activas y contenido del CMS.',
      sitemapUpdated: 'Sitemap actualizado',
      sitemapUrlCopied: 'URL copiada',
      includedContentSection: 'Contenido incluido',
      includedStaticPages: 'Páginas estáticas (inicio, pricing, blog)',
      includedLandingPages: 'Landing pages dinámicas activas',
      includedBlogArticles: 'Artículos del blog publicados',
      excludedHint: 'Las páginas privadas (dashboard, workspace) se excluyen automáticamente.',
      metaBasicSection: 'Meta básica',
      metaTitleLabelTpl: 'Meta title ({n}/60 recomendado)',
      metaDescriptionLabelTpl: 'Meta description ({n}/155 recomendado)',
      focusKeyword: 'Focus keyword',
      canonicalUrl: 'URL canónica',
      canonicalPlaceholder: 'https://www.ezdocu.ai/...',
      noindexLabel: 'noindex',
      nofollowLabel: 'nofollow',
      openGraphSection: 'Open Graph',
      ogTitle: 'OG title',
      ogDescription: 'OG description',
      ogImageUrl: 'OG image URL',
      ogImageUrlPlaceholder: 'https://...',
      twitterSection: 'Twitter Cards',
      twitterCard: 'Twitter card',
      twitterSite: 'Twitter @site',
      twitterSitePlaceholder: '@ezdocuai',
      twitterTitle: 'Twitter title',
      twitterDescription: 'Twitter description',
      twitterImage: 'Twitter image URL',
      jsonLdSection: 'JSON-LD',
      jsonLdLabel: 'Schemas (array de { type, jsonLd })',
      jsonLdHint: 'Se inyecta dentro de <head> al renderizar la página.',
      jsonLdInvalid: 'JSON-LD inválido',
      changesPublished: 'Cambios publicados',
      previewGoogle: 'Preview Google',
      previewOg: 'Preview OG',
      infoSection: 'Info',
      pageKeyLabel: 'page_key',
      lastEdited: 'Última edición',
    },
    apiKeys: {
      title: 'API Keys',
      subtitle: 'Gestioná las claves de acceso de integraciones externas (Ranqio, etc.). Podés configurar un webhook para recibir confirmación cuando EZDocuAI procese un artículo.',
      noKeys: 'No hay API keys creadas todavía.',
      webhookDeleted: 'Webhook eliminado',
      webhookSaved: 'Webhook guardado',
      saveError: 'Error al guardar',
      copiedToClipboard: '✓ Copiado al portapapeles',
      statusActive: 'activa',
      statusRevoked: 'revocada',
      webhookBadge: 'webhook',
      rateLimitTpl: '{n}/min',
      lastUsedTpl: 'última vez: {when}',
      lastUsedNever: 'nunca',
      lastDeliveryTpl: 'última entrega: HTTP {status}',
      noDeliveriesYet: 'sin entregas aún',
      editWebhook: 'Editar webhook',
      configureWebhook: 'Configurar webhook',
      webhookUrlLabel: 'URL del webhook',
      webhookUrlPlaceholder: 'https://tu-dominio.com/webhooks/ezdocu',
      webhookUrlHint: 'EZDocuAI enviará un POST firmado aquí cuando se cree, actualice o elimine un artículo desde esta API key.',
      secretLabel: 'Secret (opcional)',
      secretPlaceholder: 'Se genera automáticamente si lo dejás vacío',
      secretHint: 'Se usa para firmar cada request (HMAC-SHA256) en el header X-EZDocu-Signature.',
      showSecret: 'Mostrar',
      hideSecret: 'Ocultar',
      saveSecretWarning: '⚠ Guardá este secret — no se muestra otra vez',
      deleteWebhook: 'Eliminar webhook',
      cancel: 'Cancelar',
      save: 'Guardar',
      payloadExample: 'Payload del webhook (ejemplo)',
    },
    landingPages: {
      title: 'Landing Pages',
      subtitle: 'Gestioná las landing pages dinámicas: ofertas, promociones, eventos.',
      newPage: 'Nueva página',
      noPages: 'Todavía no hay landing pages',
      createFirst: 'Crear la primera',
      deleteConfirm: '¿Eliminar esta landing page? Esta acción no se puede deshacer.',
      totalLbl: 'Total',
      activeLbl: 'Activas',
      draftsLbl: 'Borradores',
      titleCol: 'Título',
      slug: 'Slug',
      status: 'Estado',
      updated: 'Actualizada',
      actions: 'Acciones',
      activeBadge: 'Activa',
      draftBadge: 'Borrador',
      viewSite: 'Ver',
      editPage: 'Editar',
      deletePage: 'Eliminar',
      slugTitleRequired: 'Slug y título son obligatorios',
      errorCreate: 'Error al crear',
      errorSave: 'Error al guardar',
      errorPublish: 'Error al publicar',
      draftSavedMsg: '✓ Borrador guardado. No es visible al público todavía.',
      publishedMsg: '🚀 Publicado. Los visitantes ya ven los cambios.',
      draftDiscarded: 'Borrador descartado',
      draftUnpublished: 'Borrador sin publicar',
      errorCreatePage: 'Error al crear la página',
      errorSaveDraft: 'Error al guardar el borrador',
    },
    templates: {
      title: 'Plantillas de certificados',
      subtitle: 'Gestioná las plantillas de certificado globales disponibles para todas las cuentas.',
      noTemplates: 'No hay plantillas todavía',
      uploadTemplate: 'Subir plantilla',
      newTemplate: 'Nueva plantilla',
      editTemplate: 'Editar plantilla',
      activateTemplate: 'Activar',
      deactivateTemplate: 'Desactivar',
      default: 'Predeterminada',
      global: 'Global',
      custom: 'Personalizada',
      uploadDocx: 'Subir DOCX',
      globalTemplatesStat: 'Plantillas globales',
      activeStat: 'Activas',
      defaultStat: 'Predeterminadas',
      inactiveStat: 'Inactivas',
      categoryGeneral: 'General',
      categoryLegal: 'Legal',
      categoryImmigration: 'Inmigración',
      categoryAcademic: 'Académica',
      allTemplatesFilter: 'Todas las plantillas',
      colTemplate: 'Plantilla',
      colCategory: 'Categoría',
      colAccount: 'Cuenta',
      colFlags: 'Flags',
      colCreated: 'Creada',
      colActions: 'Acciones',
      colActive: 'Activa',
      loadingTemplates: 'Cargando plantillas...',
      noTemplatesFound: 'No se encontraron plantillas.',
      flagDefault: 'Predeterminada',
      flagGlobal: 'Global',
      editBtn: 'Editar',
      newGlobalTemplate: 'Nueva plantilla global',
      uploadTemplateDialog: 'Subir plantilla',
      nameLabel: 'Nombre',
      namePlaceholder: 'Ej. Certificado de traducción',
      descriptionLabel: 'Descripción (opcional)',
      descriptionPlaceholder: 'Breve descripción de esta plantilla',
      categoryLabel: 'Categoría',
      languageLabel: 'Idioma',
      anyLanguage: 'Cualquier idioma',
      languageEnglish: 'Inglés',
      languageSpanish: 'Español',
      languagePortuguese: 'Portugués',
      cancelBtn: 'Cancelar',
      createAndEdit: 'Crear y editar',
      creatingBtn: 'Creando...',
      editingGlobalTemplate: 'Editando plantilla global',
      variablesBtn: 'Variables',
      clickToCopyHint: 'Click para copiar → Ctrl+V',
      copiedTooltip: '✓ ¡Copiado!',
      clickToCopyTooltip: 'Click para copiar → {description}',
      saveAndClose: 'Guardar y cerrar',
      savingBtn: 'Guardando...',
      variableTranslatorName: 'Nombre completo del traductor',
      variableTranslatorEmail: 'Email del traductor',
      variableCertificationDate: 'Fecha de certificación',
      variableOrderDate: 'Fecha en que se creó la orden',
      variableCompletionDate: 'Fecha en que se completó la orden',
      variableSourceLanguage: 'Idioma original del documento',
      variableTargetLanguage: 'Idioma de traducción',
      variableSourceCountry: 'País de origen',
      variableTargetCountry: 'País de destino',
      variableDocumentTitle: 'Título del documento',
      variableDocumentType: 'Categoría/tipo de documento',
      variablePageCount: 'Cantidad de páginas',
      variableOrderNumber: 'Número de referencia de la orden',
      variableProjectNumber: 'Número de referencia del proyecto',
      failedToPrepareTpl: 'No se pudo preparar la plantilla: {message}',
      failedToSaveTpl: 'No se pudo guardar la plantilla: {message}',
      failedToSaveGeneric: 'No se pudo guardar la plantilla. Revisá la consola para más detalles.',
      failedToCreate: 'No se pudo crear la plantilla',
    },
  },
  adminPayments: {
    title: 'Pagos',
    transactionsOne: '{n} transacción',
    transactionsOther: '{n} transacciones',
    subtitle: 'compras de plan, packs de créditos, renovaciones y auto-recargas',
    refresh: 'Actualizar',
    exportExcel: 'Exportar Excel',
    exporting: 'Exportando…',
    exportError: 'No se pudo exportar: inténtalo de nuevo.',
    searchPlaceholder: 'Buscar por cliente, correo, cuenta, plan o Stripe ID…',
    countOf: '{n} de {total}',
    loading: 'Cargando…',
    empty: 'Todavía no hay pagos registrados.',
    emptyFiltered: 'Ningún pago coincide con estos filtros.',
    viewAccount: 'Ver cuenta',
    staleBackend: 'El servidor todavía no aplica estos filtros: la tabla solo filtra los 200 pagos más recientes y los totales son de todos los pagos. El Excel sí sale completo y filtrado.',
    filters: {
      period: 'Periodo',
      type: 'Tipo',
      status: 'Estado',
      from: 'Desde',
      to: 'Hasta',
      clear: 'Limpiar filtros',
      sinceDate: 'Desde el {date}',
      untilDate: 'Hasta el {date}',
    },
    periods: {
      all: 'Todo',
      thisMonth: 'Este mes',
      lastMonth: 'Mes anterior',
      last30Days: 'Últimos 30 días',
      thisYear: 'Este año',
      custom: 'Personalizado',
    },
    categories: {
      all: 'Todos',
      plan: 'Planes',
      credits: 'Packs de créditos',
      autoRecharge: 'Auto-recargas',
      refund: 'Reembolsos',
    },
    statusAll: 'Todos',
    statuses: {
      active: 'Activa',
      trial: 'En prueba',
      cancelsAtEnd: 'Se cancela',
      canceled: 'Cancelada',
      unpaid: 'Impago',
      incomplete: 'Incompleta',
      unknown: 'Sin dato',
      paid: 'Pagado',
      refund: 'Reembolso',
    },
    statusHelp: {
      active: 'Suscripción activa: se renovará sola.',
      cancelsAtEnd: 'Cancelada por el cliente: no se renovará al final del periodo.',
      unpaid: 'Stripe no pudo cobrar la renovación.',
      unknown: 'No se pudo consultar Stripe; el próximo cobro es una estimación.',
    },
    cycles: {
      yearly: 'Anual',
      monthly: 'Mensual',
    },
    items: {
      plan: 'Plan',
      creditPack: 'Pack de créditos',
      autoRecharge: 'Auto-recarga',
      refund: 'Reembolso',
    },
    cards: {
      revenue: 'Ingresos',
      total: 'Total',
      netAndRefunds: 'Neto {net} · reembolsos {refunds}',
      customersOne: '{n} cliente',
      customersOther: '{n} clientes',
      thisMonth: 'Este mes',
      plans: 'Planes',
      paymentsOne: '{n} pago',
      paymentsOther: '{n} pagos',
      creditPacks: 'Packs de créditos',
      purchasesOne: '{n} compra',
      purchasesOther: '{n} compras',
      activeSubscriptions: 'Suscripciones activas',
      today: 'Hoy',
      mrr: 'MRR {usd}',
      cancelling: '{n} por cancelar',
      unpaid: '{n} en impago',
      unknown: '{n} sin dato',
      creditsSold: 'Créditos vendidos',
    },
    columns: {
      date: 'Fecha',
      customer: 'Cliente',
      account: 'Cuenta',
      item: 'Concepto',
      cycle: 'Ciclo',
      status: 'Estado',
      nextCharge: 'Próx. cobro',
      description: 'Descripción',
      credits: 'Créditos',
      amount: 'Importe',
      stripeId: 'Stripe ID',
      mode: 'Modo',
    },
    excel: {
      sheet: 'Pagos',
      date: 'Fecha',
      customer: 'Cliente',
      email: 'Correo',
      account: 'Cuenta',
      type: 'Tipo',
      cycle: 'Ciclo',
      status: 'Estado',
      nextCharge: 'Próximo cobro',
      description: 'Descripción',
      credits: 'Créditos',
      amountUsd: 'Importe USD',
      stripeId: 'Stripe ID',
      mode: 'Modo',
    },
  },
  glossary: {
    title: 'Glosario global',
    subtitle: 'Terminología compartida entre todas las cuentas. Usado en traducciones automáticas.',
    categoriesBtn: 'Categorías',
    uploadFile: 'Subir archivo',
    newTerm: 'Nuevo término',
    breadcrumbRoot: 'Glosario',
    categoriesWithDataTpl: 'Categorías con términos ({n})',
    emptyCategoriesTpl: 'Categorías vacías ({n})',
    termsCountOne: '{n} término',
    termsCountOther: '{n} términos',
    pairsCountOne: '{n} par',
    pairsCountOther: '{n} pares',
    defsCountTpl: '{n} def.',
    backToCategories: 'Categorías',
    pairType: 'Par bilingüe',
    definitionType: 'Monolingüe (definición)',
    pairTypeDescTpl: 'Término + traducción. {n} entradas.',
    definitionTypeDescTpl: 'Término + definición. {n} entradas.',
    backToTypes: 'Tipos',
    langComboTermsTpl: '{n} términos · {combo}',
    emptyType: 'No hay entradas en este tipo.',
    deleteLangTitle: 'Eliminar términos',
    deleteLangBodyTpl: 'Vas a eliminar {n} términos de {cat} · {combo}.',
    deleteCannotUndo: 'Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    deleteCountTpl: 'Eliminar {n}',
    backToLanguages: 'Idiomas',
    filterByLetter: 'Filtrar por letra',
    allLetters: 'Todas',
    search: 'Buscar',
    searchPlaceholder: 'Buscar término o traducción...',
    onlyVerified: 'Solo verificados',
    refresh: 'Refrescar',
    downloadPdf: 'Descargar PDF',
    generatingPdf: 'Generando…',
    downloadPdfTipFiltered: 'La descarga respeta los filtros activos',
    downloadPdfTipAll: 'Descargar TODO el glosario de esta categoría/tipo',
    selectFilterCountTpl: 'Seleccionar los {n} términos del filtro',
    selectedCountTpl: '{n} seleccionados',
    allFilter: '(todo el filtro)',
    verify: 'Verificar',
    unverify: 'Desmarcar',
    clear: 'Limpiar',
    pageXofYTpl: 'página {p} / {t}',
    letterLabelTpl: 'letra {l}',
    otherLetter: 'otros',
    noTerms: 'No hay términos con estos filtros.',
    previous: '← Anterior',
    next: 'Siguiente →',
    term: 'Término',
    translation: 'Traducción',
    definition: 'Definición',
    source: 'Fuente',
    actions: 'Acciones',
    verifiedTitle: 'Verificado · click para desmarcar',
    unverifiedTitle: 'Sin verificar · click para aprobar',
    selectPage: 'Seleccionar esta página',
    entryNewTitle: 'Nuevo término',
    entryEditTitle: 'Editar término',
    fieldCategory: 'Categoría',
    fieldCategoryHelp: 'Agrupa términos por dominio (legal, médico, técnico...). Se usa para sugerir el glosario correcto al traducir un documento de ese tipo.',
    fieldType: 'Tipo',
    fieldTypeHelp: 'Par de traducción = término origen + término destino en otro idioma. Definición (monolingüe) = término + explicación en el mismo idioma.',
    fieldSourceTerm: 'Término origen',
    fieldSourceTermHelp: 'La palabra o frase tal cual aparece en el documento original. Se guarda en minúsculas para búsqueda insensible a mayúsculas.',
    fieldLang: 'Idioma',
    fieldSourceLangHelp: 'Idioma del término origen en código ISO-639-1 (es, en, pt, fr, it, de).',
    fieldTranslation: 'Traducción',
    fieldTranslationHelp: 'Cómo debe traducirse el término origen en el idioma destino. Se usa como referencia preferente al traducir.',
    fieldTargetLangHelp: 'Idioma del término traducido (ISO-639-1).',
    fieldDefinition: 'Definición',
    fieldDefinitionHelp: 'Explicación del término en el mismo idioma del origen. Útil para términos técnicos o legales sin traducción directa.',
    fieldContext: 'Contexto (opcional)',
    fieldContextHelp: 'Notas sobre cuándo aplica este término (país, subdominio, registro). Sólo sirve de guía para el revisor.',
    fieldPriority: 'Prioridad (0-100)',
    fieldPriorityHelp: 'Ante términos duplicados, el de mayor prioridad gana. 0 = normal, 50+ = preferente, 100 = forzar siempre.',
    fieldVerified: 'Verificado',
    fieldVerifiedHelp: 'Marca términos revisados por un humano. Los verificados tienen prioridad sobre los no verificados al traducir.',
    fieldSourceKind: 'Tipo de fuente',
    fieldSourceKindHelp: 'De dónde viene el término: Manual, PDF/CSV/TXT, IA (Claude), Web (página pública), Cliente (documento privado).',
    fieldSourceLabel: 'Nombre / referencia',
    fieldSourceLabelHelp: 'Nombre legible de la fuente para auditoría. Aparece en la columna Fuente de la tabla.',
    fieldSourceUrl: 'URL (si viene de web)',
    fieldSourceUrlHelp: 'Enlace canónico a la página original. Si está vacío no se muestra link en la tabla.',
    fieldSourceUrlHint: 'Ej: https://www.justicia.ar/herramientas/glosario',
    provenanceTitle: 'Fuente / Procedencia',
    selectPlaceholder: '— Seleccionar —',
    entryPairOption: 'Par de traducción',
    entryDefinitionOption: 'Definición (monolingüe)',
    save: 'Guardar',
    sourceTermPlaceholder: 'Ej: acta de nacimiento',
    translationPlaceholder: 'Ej: birth certificate',
    definitionPlaceholder: 'Definición del término en el mismo idioma de origen...',
    contextPlaceholder: 'Ej: usado en documentos legales de Colombia',
    sourceLabelPlaceholder: 'Ej: Cabanellas 2023 / Cliente ACME',
    originalFile: 'Archivo original',
    sourceManual: 'Manual',
    sourcePdf: 'PDF',
    sourceCsv: 'CSV',
    sourceTxt: 'TXT',
    sourceAi: 'IA',
    sourceLearning: 'Traducción',
    sourceWeb: 'Web',
    sourceClient: 'Cliente',
    uploadTitle: 'Subir glosario',
    uploadConfirmTitle: 'Confirmar datos',
    tabFile: 'Archivo',
    tabUrl: 'URL',
    tabPaste: 'Pegar texto',
    uploadClickToSelect: 'Click para seleccionar archivo',
    uploadHint: 'PDF, CSV o TXT · sin límite de tamaño',
    uploadAnalyzing: 'Claude está analizando el archivo…',
    urlFieldLabel: 'URL del glosario',
    urlFieldHint: 'Ej: https://www.justicia.ar/herramientas/glosario',
    analyzeUrl: 'Analizar URL',
    readingPage: 'Leyendo página…',
    pageTitleLabel: 'Título',
    pasteFieldLabel: 'Contenido (pegar desde Claude Max, Excel, web, etc.)',
    pasteFieldHint: 'Se detecta CSV si hay comas + saltos de línea; si no, se procesa como texto libre',
    pastePlaceholder: 'source_term,source_lang,target_term,target_lang,entry_type\nabsolución,es,acquittal,en,pair\n...',
    sourceName: 'Nombre de la fuente',
    sourceNamePlaceholder: 'Ej: Claude Max — Glosario legal',
    originalUrlOptional: 'URL original (opcional)',
    analyzeText: 'Analizar texto',
    analyzing: 'Analizando…',
    claudeHelpTitle: '💡 Qué hace Claude al subir:',
    claudeHelpDetectLangs: 'Detecta idiomas (origen / destino)',
    claudeHelpDetectType: 'Detecta tipo (par bilingüe o monolingüe)',
    claudeHelpSuggestCategory: 'Sugiere categoría adecuada',
    claudeHelpSaveSource: 'Guarda la fuente (archivo / URL / label) en cada término',
    claudeAnalyzedTpl: 'Claude analizó {file} ({chars} chars). Revisá y editá si algo no cuadra.',
    destCategory: 'Categoría destino',
    contentType: 'Tipo de contenido',
    pairOption: 'Par bilingüe',
    monolingualOption: 'Monolingüe',
    srcLang: 'Idioma origen',
    tgtLang: 'Idioma destino',
    savedSource: 'Fuente guardada en cada término',
    changeSource: '← Cambiar fuente',
    process: 'Procesar',
    urlInvalid: 'URL inválida',
    urlEmpty: 'Ingresá una URL',
    urlNoText: 'La página no devolvió texto suficiente',
    pasteTooShort: 'Pegá al menos 200 caracteres de contenido',
    urlErrorGeneric: 'Error al analizar la URL',
    detectError: 'No se pudo detectar metadata',
    uploadErrorGeneric: 'Error al subir',
    confSure: 'seguro',
    confProbable: 'probable',
    confUnsure: 'incierto',
    msgTermCreated: 'Término creado',
    msgTermUpdated: 'Término actualizado',
    msgTermDeleted: 'Término eliminado',
    msgSaveError: 'Error al guardar',
    msgBulkVerifiedTpl: '{n} términos verificados',
    msgBulkUnverifiedTpl: '{n} términos desmarcados',
    msgVerifyError: 'Error al verificar',
    msgBulkDeletedTpl: '{n} términos eliminados',
    msgDeleteError: 'Error al eliminar',
    msgPdfDownloadedTpl: 'PDF descargado ({n} entradas)',
    msgPdfError: 'Error al exportar PDF',
    errorFetchEntries: 'Error al obtener entradas',
    helpAria: 'Ayuda',
    langNameEs: 'Español',
    langNameEn: 'Inglés',
    langNamePt: 'Portugués',
    langNameFr: 'Francés',
    langNameIt: 'Italiano',
    langNameDe: 'Alemán',
  },
  sharedComponents: {
    notificationBell: {
      ariaLabel: 'Notificaciones',
    },
    languageSelector: {
      tooltip: 'Cambiar idioma',
    },
    professionalProfile: {
      associationSearchHint: 'Buscá entre 85+ asociaciones verificadas o escribí "Otra"',
      associationSearchPlaceholder: 'Buscar asociación (ej: ATA, BDÜ, CTPCBA...)',
      noResults: 'Sin resultados',
    },
  },
  verifyPublic: {
    humanVerified: 'Verificado por humano',
    kmsSigned: 'Firmado con KMS',
    translationOnRecord: 'Traducción registrada',
    statusHashing: 'Verificando archivo…',
    statusPurgedWithHash: 'Esta traducción fue completada y firmada por el traductor arriba. El archivo original ya no está almacenado en nuestros servidores, pero podés subir tu copia abajo para verificar que la firma coincida — el archivo se chequea en tu navegador y nunca sale de tu dispositivo.',
    statusWithHash: 'Esta traducción fue completada y firmada por el traductor arriba. Para confirmar que el PDF que recibiste es auténtico, subílo abajo — el archivo se chequea en tu navegador y nunca sale de tu dispositivo.',
    statusNoHash: 'Esta traducción fue completada y firmada por el traductor arriba. El contenido firmado está almacenado en nuestros servidores y no ha sido modificado.',
    documentVerifiedTitle: 'Documento verificado',
    documentVerifiedDesc: 'El archivo subido coincide exactamente con la traducción firmada. Este documento no ha sido modificado.',
    fileMismatchTitle: 'Archivo no coincide',
    fileMismatchDesc: 'El archivo subido no coincide con la traducción firmada. Incluso acciones menores como reguardar o comprimir pueden causar una discrepancia. Por favor solicitá el archivo firmado e intentá de nuevo.',
    documentDetailsLabel: 'Detalles del documento',
    documentField: 'Documento',
    orderField: 'Orden',
    languagesField: 'Idiomas',
    pagesField: 'Páginas',
    verifiedByField: 'Verificado por',
    verifiedOnField: 'Verificado el',
    verifyIntegrityLabel: 'Verificar integridad del documento',
    computingHash: 'Calculando hash…',
    dropzoneTitlePurged: 'Subí tu copia del PDF firmado',
    dropzoneTitle: 'Subí el PDF provisto por el traductor',
    dropzoneHintPurged: 'El archivo ya no está en nuestros servidores. Su hash queda firmado en nuestra base de datos y se compara con el tuyo únicamente en tu navegador.',
    dropzoneHint: 'El archivo se chequea sólo en tu navegador. Nunca sale de tu dispositivo.',
    fileNotAvailableBox: 'La comparación directa de archivo no está disponible para este registro. El contenido de la traducción fue firmado criptográficamente al momento de la verificación y permanece inalterado en nuestros servidores.',
    disclaimerPurged: 'Zero-knowledge por diseño: el archivo firmado ya no está en nuestros servidores, pero su huella criptográfica queda almacenada permanentemente. Subí tu copia para probar que coincide con la que firmó el traductor.',
    disclaimerWithHash: 'Esta página por sí sola confirma que una traducción está registrada con este profesional. No valida el archivo en tu poder hasta que lo subas para comparar.',
    disclaimerNoHash: 'Esta página confirma que una traducción está registrada con este profesional. La comparación por upload no está disponible para este registro; la integridad está garantizada a nivel de contenido.',
    saveBtn: 'Guardar esta verificación',
    verificationResultLabel: 'Resultado de la verificación',
    exactMatchTitle: 'Coincidencia exacta confirmada',
    exactMatchDesc: 'El archivo subido es idéntico a la traducción firmada.',
    certificationStatementLabel: 'Declaración de certificación',
    defaultCertStatement: 'Certifico que esta es una traducción fiel y exacta del documento original, según mi mejor conocimiento y capacidad.',
    verifiedDisclaimer: 'El archivo subido coincide exactamente con la traducción firmada emitida por el traductor. EZDocuAI sólo verifica la integridad del archivo. El traductor es el único responsable del contenido y la precisión de esta traducción.',
    reverifyBtn: 'Re-verificar',
    fileMismatchResultTitle: 'Discrepancia de archivo detectada',
    fileMismatchResultDesc: 'El archivo subido no coincide con la traducción firmada.',
    mismatchDisclaimer: 'EZDocuAI no analiza qué cambió. Sólo verifica si el archivo subido es idéntico a la traducción firmada.',
    inspectedCannotConfirmTitle: 'No podemos confirmar este archivo',
    inspectedCannotConfirmDesc: 'No se guardó un hash de archivo para esta verificación, así que no podemos confirmar si el PDF que subiste es el que firmó el traductor. Pedile el archivo firmado directamente al traductor.',
    yourFileHashLabel: 'Hash de tu archivo (SHA-256)',
    inspectedDisclaimer: 'Tu archivo nunca salió del navegador — sólo calculamos el SHA-256 localmente y lo dejamos en pantalla como constancia. Un veredicto definitivo de coincidencia o no coincidencia sólo es posible para verificaciones que guardaron el hash del PDF firmado en el momento de firmar.',
    tryAgainBtn: 'Intentar de nuevo',
    contactTranslatorBtn: 'Contactar al traductor',
    mailtoSubject: 'Discrepancia de verificación – {order}',
    mailtoBody: 'Estimado/a {translator},\n\nIntenté verificar una traducción a través de EZDocuAI y el archivo subido no coincidió con la versión firmada en el registro.\n\nOrden: {order}\nDocumento: {document}\n\n¿Podría proveerme una nueva copia digital certificada?\n\nGracias.',
    cryptographicDetails: 'Detalles criptográficos',
    verificationIdLabel: 'ID de verificación',
    documentHashLabel: 'Hash del documento (SHA-256)',
    contentHashLabel: 'Hash del contenido (SHA-256)',
    localVerificationNote: 'Verificación local: el archivo se chequea en tu navegador y nunca se sube a ningún servidor.',
    verificationIssuedAt: 'Verificación emitida el {date} a las {time} UTC',
    poweredBy: 'Desarrollado por',
    footerDisclaimer: 'EZDocuAI es exclusivamente un proveedor de tecnología. No evaluamos el contenido del documento, la precisión de la traducción ni el cumplimiento legal. Esta página sólo confirma la integridad técnica del archivo digital.',
    zeroKnowledgeEncrypted: 'Cifrado Zero Knowledge',
    notFoundTitle: 'Verificación no encontrada',
    notFoundDesc: 'El certificado de verificación de traducción que estás buscando no existe o el ID es inválido.',
    goToHome: 'Ir a EZDocuAI',
  },
};
